/**
 * This file was auto-generated by @openapi-qraft/cli.
 * Do not make direct changes to the file.
 */

import type {
  DeepReadonly,
  MutationFiltersByMutationKey,
  MutationFiltersByParameters,
  MutationVariables,
  OperationError,
  QraftServiceOperationsToken,
  RequestFnResponse,
  ServiceOperationMutationFnOptions,
  ServiceOperationMutationKey,
  ServiceOperationUseMutationOptions,
} from '@openapi-qraft/tanstack-query-react-types';
import type { Mutation, MutationCache, MutationState, UseMutationResult } from '@tanstack/react-query';

import type { paths } from '../schema';

export interface AgentToolsService {
  /**
   * @summary Get Customers By Phone Endpoint
   * @description Get customers by phone number.
   *
   * Search for customers using their phone number. The phone number will be validated
   * and normalized to E164 format before searching.
   *
   * For testing in FastAPI docs:
   * 1. Ensure you have a valid retell_agent_id in the voice_agents table
   * 2. Include x-retell-signature header (for testing, you may need to disable signature verification)
   */
  getCustomersByPhoneEndpointAgentToolCustomerGetByPhonePost: {
    /**
     * @summary Get Customers By Phone Endpoint
     * @description Get customers by phone number.
     *
     * Search for customers using their phone number. The phone number will be validated
     * and normalized to E164 format before searching.
     *
     * For testing in FastAPI docs:
     * 1. Ensure you have a valid retell_agent_id in the voice_agents table
     * 2. Include x-retell-signature header (for testing, you may need to disable signature verification)
     */
    <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(
      options: ServiceOperationMutationFnOptions<
        GetCustomersByPhoneEndpointAgentToolCustomerGetByPhonePostBody,
        GetCustomersByPhoneEndpointAgentToolCustomerGetByPhonePostParameters,
        TMeta,
        TSignal
      >,
      client?: (
        schema: GetCustomersByPhoneEndpointAgentToolCustomerGetByPhonePostSchema,
        options: ServiceOperationMutationFnOptions<
          GetCustomersByPhoneEndpointAgentToolCustomerGetByPhonePostBody,
          GetCustomersByPhoneEndpointAgentToolCustomerGetByPhonePostParameters,
          TMeta,
          TSignal
        >
      ) => Promise<
        RequestFnResponse<
          GetCustomersByPhoneEndpointAgentToolCustomerGetByPhonePostData,
          GetCustomersByPhoneEndpointAgentToolCustomerGetByPhonePostError
        >
      >
    ): Promise<
      RequestFnResponse<
        GetCustomersByPhoneEndpointAgentToolCustomerGetByPhonePostData,
        GetCustomersByPhoneEndpointAgentToolCustomerGetByPhonePostError
      >
    >;
    /**
     * @summary Get Customers By Phone Endpoint
     * @description Get customers by phone number.
     *
     * Search for customers using their phone number. The phone number will be validated
     * and normalized to E164 format before searching.
     *
     * For testing in FastAPI docs:
     * 1. Ensure you have a valid retell_agent_id in the voice_agents table
     * 2. Include x-retell-signature header (for testing, you may need to disable signature verification)
     */
    getMutationKey(
      parameters: DeepReadonly<GetCustomersByPhoneEndpointAgentToolCustomerGetByPhonePostParameters> | void
    ): ServiceOperationMutationKey<
      GetCustomersByPhoneEndpointAgentToolCustomerGetByPhonePostSchema,
      GetCustomersByPhoneEndpointAgentToolCustomerGetByPhonePostParameters
    >;
    /**
     * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
     * Handles loading state, optimistic updates, and error handling.
     *
     * @summary Get Customers By Phone Endpoint
     * @description Get customers by phone number.
     *
     * Search for customers using their phone number. The phone number will be validated
     * and normalized to E164 format before searching.
     *
     * For testing in FastAPI docs:
     * 1. Ensure you have a valid retell_agent_id in the voice_agents table
     * 2. Include x-retell-signature header (for testing, you may need to disable signature verification)
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
     * @example Mutation with predefined parameters, e.g., for updating
     * ```ts
     * const { mutate, isPending } = qraft.agentToolsService.getCustomersByPhoneEndpointAgentToolCustomerGetByPhonePost.useMutation({})
     * mutate(body);
     * ```
     * @example Mutation without predefined parameters, e.g., for creating
     * ```ts
     * const { mutate, isPending } = qraft.agentToolsService.getCustomersByPhoneEndpointAgentToolCustomerGetByPhonePost.useMutation()
     * mutate({
     *     body: bodyPayload
     * });
     * ```
     */
    useMutation<TVariables extends GetCustomersByPhoneEndpointAgentToolCustomerGetByPhonePostBody, TContext = unknown>(
      parameters: DeepReadonly<GetCustomersByPhoneEndpointAgentToolCustomerGetByPhonePostParameters>,
      options?: ServiceOperationUseMutationOptions<
        GetCustomersByPhoneEndpointAgentToolCustomerGetByPhonePostSchema,
        GetCustomersByPhoneEndpointAgentToolCustomerGetByPhonePostData,
        GetCustomersByPhoneEndpointAgentToolCustomerGetByPhonePostParameters,
        TVariables,
        OperationError<GetCustomersByPhoneEndpointAgentToolCustomerGetByPhonePostError>,
        TContext
      >
    ): UseMutationResult<
      GetCustomersByPhoneEndpointAgentToolCustomerGetByPhonePostData,
      OperationError<GetCustomersByPhoneEndpointAgentToolCustomerGetByPhonePostError>,
      TVariables,
      TContext
    >;
    /**
     * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
     * Handles loading state, optimistic updates, and error handling.
     *
     * @summary Get Customers By Phone Endpoint
     * @description Get customers by phone number.
     *
     * Search for customers using their phone number. The phone number will be validated
     * and normalized to E164 format before searching.
     *
     * For testing in FastAPI docs:
     * 1. Ensure you have a valid retell_agent_id in the voice_agents table
     * 2. Include x-retell-signature header (for testing, you may need to disable signature verification)
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
     * @example Mutation with predefined parameters, e.g., for updating
     * ```ts
     * const { mutate, isPending } = qraft.agentToolsService.getCustomersByPhoneEndpointAgentToolCustomerGetByPhonePost.useMutation({})
     * mutate(body);
     * ```
     * @example Mutation without predefined parameters, e.g., for creating
     * ```ts
     * const { mutate, isPending } = qraft.agentToolsService.getCustomersByPhoneEndpointAgentToolCustomerGetByPhonePost.useMutation()
     * mutate({
     *     body: bodyPayload
     * });
     * ```
     */
    useMutation<
      TVariables extends MutationVariables<
        GetCustomersByPhoneEndpointAgentToolCustomerGetByPhonePostBody,
        GetCustomersByPhoneEndpointAgentToolCustomerGetByPhonePostParameters
      >,
      TContext = unknown,
    >(
      parameters: void,
      options?: ServiceOperationUseMutationOptions<
        GetCustomersByPhoneEndpointAgentToolCustomerGetByPhonePostSchema,
        GetCustomersByPhoneEndpointAgentToolCustomerGetByPhonePostData,
        GetCustomersByPhoneEndpointAgentToolCustomerGetByPhonePostParameters,
        TVariables,
        OperationError<GetCustomersByPhoneEndpointAgentToolCustomerGetByPhonePostError>,
        TContext
      >
    ): UseMutationResult<
      GetCustomersByPhoneEndpointAgentToolCustomerGetByPhonePostData,
      OperationError<GetCustomersByPhoneEndpointAgentToolCustomerGetByPhonePostError>,
      TVariables,
      TContext
    >;
    /**
     * Returns the count of currently in-progress mutations.
     *
     * @summary Get Customers By Phone Endpoint
     * @description Get customers by phone number.
     *
     * Search for customers using their phone number. The phone number will be validated
     * and normalized to E164 format before searching.
     *
     * For testing in FastAPI docs:
     * 1. Ensure you have a valid retell_agent_id in the voice_agents table
     * 2. Include x-retell-signature header (for testing, you may need to disable signature verification)
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsMutating|`useIsMutating(...)` documentation}
     * @example Check how many mutations are currently in progress for the specified service method.
     * ```ts
     * const getCustomersByPhoneEndpointAgentToolCustomerGetByPhonePostTotal = qraft.agentToolsService.getCustomersByPhoneEndpointAgentToolCustomerGetByPhonePost.useIsMutating()
     * ```
     * @example Check how many mutations are currently in progress with the specified parameters.
     * ```ts
     * const getCustomersByPhoneEndpointAgentToolCustomerGetByPhonePostTotal = qraft.agentToolsService.getCustomersByPhoneEndpointAgentToolCustomerGetByPhonePost.useIsMutating({
     *     parameters: {}
     * })
     * ```
     */
    useIsMutating<TContext = unknown>(
      filters?:
        | MutationFiltersByParameters<
            GetCustomersByPhoneEndpointAgentToolCustomerGetByPhonePostBody,
            GetCustomersByPhoneEndpointAgentToolCustomerGetByPhonePostData,
            GetCustomersByPhoneEndpointAgentToolCustomerGetByPhonePostParameters,
            OperationError<GetCustomersByPhoneEndpointAgentToolCustomerGetByPhonePostError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            GetCustomersByPhoneEndpointAgentToolCustomerGetByPhonePostSchema,
            GetCustomersByPhoneEndpointAgentToolCustomerGetByPhonePostBody,
            GetCustomersByPhoneEndpointAgentToolCustomerGetByPhonePostData,
            GetCustomersByPhoneEndpointAgentToolCustomerGetByPhonePostParameters,
            OperationError<GetCustomersByPhoneEndpointAgentToolCustomerGetByPhonePostError>,
            TContext
          >
    ): number;
    /**
     * Provides access to the current state of a mutation, including its status, any resulting data, and associated errors.
     *
     * @summary Get Customers By Phone Endpoint
     * @description Get customers by phone number.
     *
     * Search for customers using their phone number. The phone number will be validated
     * and normalized to E164 format before searching.
     *
     * For testing in FastAPI docs:
     * 1. Ensure you have a valid retell_agent_id in the voice_agents table
     * 2. Include x-retell-signature header (for testing, you may need to disable signature verification)
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutationState|`useMutationState(...)` documentation}
     * @example Get all variables of all running mutations.
     * ```ts
     * const getCustomersByPhoneEndpointAgentToolCustomerGetByPhonePostPendingMutationVariables = qraft.agentToolsService.getCustomersByPhoneEndpointAgentToolCustomerGetByPhonePost.useMutationState({
     *     filters: {
     *         status: "pending"
     *     },
     *     select: mutation => mutation.state.variables
     * })
     * ```
     * @example Get all data for specific mutations via the `parameters`.
     * ```ts
     * const getCustomersByPhoneEndpointAgentToolCustomerGetByPhonePostMutationData = qraft.agentToolsService.getCustomersByPhoneEndpointAgentToolCustomerGetByPhonePost.useMutationState({
     *     filters: {
     *         parameters: {}
     *     },
     *     select: mutation => mutation.state.data
     * })
     * ```
     */
    useMutationState<
      TContext = unknown,
      TResult = MutationState<
        GetCustomersByPhoneEndpointAgentToolCustomerGetByPhonePostData,
        OperationError<GetCustomersByPhoneEndpointAgentToolCustomerGetByPhonePostError>,
        MutationVariables<
          GetCustomersByPhoneEndpointAgentToolCustomerGetByPhonePostBody,
          GetCustomersByPhoneEndpointAgentToolCustomerGetByPhonePostParameters
        >,
        TContext
      >,
    >(options?: {
      filters?:
        | MutationFiltersByParameters<
            GetCustomersByPhoneEndpointAgentToolCustomerGetByPhonePostBody,
            GetCustomersByPhoneEndpointAgentToolCustomerGetByPhonePostData,
            GetCustomersByPhoneEndpointAgentToolCustomerGetByPhonePostParameters,
            OperationError<GetCustomersByPhoneEndpointAgentToolCustomerGetByPhonePostError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            GetCustomersByPhoneEndpointAgentToolCustomerGetByPhonePostSchema,
            GetCustomersByPhoneEndpointAgentToolCustomerGetByPhonePostBody,
            GetCustomersByPhoneEndpointAgentToolCustomerGetByPhonePostData,
            GetCustomersByPhoneEndpointAgentToolCustomerGetByPhonePostParameters,
            OperationError<GetCustomersByPhoneEndpointAgentToolCustomerGetByPhonePostError>,
            TContext
          >;
      select?: (
        mutation: Mutation<
          GetCustomersByPhoneEndpointAgentToolCustomerGetByPhonePostData,
          OperationError<GetCustomersByPhoneEndpointAgentToolCustomerGetByPhonePostError>,
          MutationVariables<
            GetCustomersByPhoneEndpointAgentToolCustomerGetByPhonePostBody,
            GetCustomersByPhoneEndpointAgentToolCustomerGetByPhonePostParameters
          >,
          TContext
        >
      ) => TResult;
    }): Array<TResult>;
    /**
     * @summary Get Customers By Phone Endpoint
     * @description Get customers by phone number.
     *
     * Search for customers using their phone number. The phone number will be validated
     * and normalized to E164 format before searching.
     *
     * For testing in FastAPI docs:
     * 1. Ensure you have a valid retell_agent_id in the voice_agents table
     * 2. Include x-retell-signature header (for testing, you may need to disable signature verification)
     */
    isMutating<TContext>(
      filters?:
        | MutationFiltersByParameters<
            GetCustomersByPhoneEndpointAgentToolCustomerGetByPhonePostBody,
            GetCustomersByPhoneEndpointAgentToolCustomerGetByPhonePostData,
            GetCustomersByPhoneEndpointAgentToolCustomerGetByPhonePostParameters,
            OperationError<GetCustomersByPhoneEndpointAgentToolCustomerGetByPhonePostError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            GetCustomersByPhoneEndpointAgentToolCustomerGetByPhonePostSchema,
            GetCustomersByPhoneEndpointAgentToolCustomerGetByPhonePostBody,
            GetCustomersByPhoneEndpointAgentToolCustomerGetByPhonePostData,
            GetCustomersByPhoneEndpointAgentToolCustomerGetByPhonePostParameters,
            OperationError<GetCustomersByPhoneEndpointAgentToolCustomerGetByPhonePostError>,
            TContext
          >
    ): number;
    /**
     * Returns a `MutationCache` object that provides access to mutation cache operations
     * for the specific endpoint.
     *
     * @summary Get Customers By Phone Endpoint
     * @description Get customers by phone number.
     *
     * Search for customers using their phone number. The phone number will be validated
     * and normalized to E164 format before searching.
     *
     * For testing in FastAPI docs:
     * 1. Ensure you have a valid retell_agent_id in the voice_agents table
     * 2. Include x-retell-signature header (for testing, you may need to disable signature verification)
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/query-client/getMutationCache|`getMutationCache(...)` documentation}
     *
     * @example Find a mutation with specific parameters
     * ```ts
     * const mutationCache = qraft.agentToolsService.getCustomersByPhoneEndpointAgentToolCustomerGetByPhonePost.getMutationCache();
     * const mutation = mutationCache.find({
     *     parameters: {}
     * });
     * ```
     *
     * @example Find all mutations for the endpoint
     * ```ts
     * const mutationCache = qraft.agentToolsService.getCustomersByPhoneEndpointAgentToolCustomerGetByPhonePost.getMutationCache();
     * const mutations = mutationCache.findAll();
     * ```
     */
    getMutationCache(): Omit<MutationCache, 'find' | 'findAll'> & {
      find<TContext = unknown>(
        filters:
          | MutationFiltersByParameters<
              GetCustomersByPhoneEndpointAgentToolCustomerGetByPhonePostBody,
              GetCustomersByPhoneEndpointAgentToolCustomerGetByPhonePostData,
              GetCustomersByPhoneEndpointAgentToolCustomerGetByPhonePostParameters,
              OperationError<GetCustomersByPhoneEndpointAgentToolCustomerGetByPhonePostError>,
              TContext
            >
          | MutationFiltersByMutationKey<
              GetCustomersByPhoneEndpointAgentToolCustomerGetByPhonePostSchema,
              GetCustomersByPhoneEndpointAgentToolCustomerGetByPhonePostBody,
              GetCustomersByPhoneEndpointAgentToolCustomerGetByPhonePostData,
              GetCustomersByPhoneEndpointAgentToolCustomerGetByPhonePostParameters,
              OperationError<GetCustomersByPhoneEndpointAgentToolCustomerGetByPhonePostError>,
              TContext
            >
      ):
        | Mutation<
            GetCustomersByPhoneEndpointAgentToolCustomerGetByPhonePostData,
            GetCustomersByPhoneEndpointAgentToolCustomerGetByPhonePostError,
            MutationVariables<
              GetCustomersByPhoneEndpointAgentToolCustomerGetByPhonePostBody,
              GetCustomersByPhoneEndpointAgentToolCustomerGetByPhonePostParameters
            >,
            TContext
          >
        | undefined;
      findAll<TContext = unknown>(
        filters?:
          | MutationFiltersByParameters<
              GetCustomersByPhoneEndpointAgentToolCustomerGetByPhonePostBody,
              GetCustomersByPhoneEndpointAgentToolCustomerGetByPhonePostData,
              GetCustomersByPhoneEndpointAgentToolCustomerGetByPhonePostParameters,
              OperationError<GetCustomersByPhoneEndpointAgentToolCustomerGetByPhonePostError>,
              TContext
            >
          | MutationFiltersByMutationKey<
              GetCustomersByPhoneEndpointAgentToolCustomerGetByPhonePostSchema,
              GetCustomersByPhoneEndpointAgentToolCustomerGetByPhonePostBody,
              GetCustomersByPhoneEndpointAgentToolCustomerGetByPhonePostData,
              GetCustomersByPhoneEndpointAgentToolCustomerGetByPhonePostParameters,
              OperationError<GetCustomersByPhoneEndpointAgentToolCustomerGetByPhonePostError>,
              TContext
            >
      ): Array<
        Mutation<
          GetCustomersByPhoneEndpointAgentToolCustomerGetByPhonePostData,
          GetCustomersByPhoneEndpointAgentToolCustomerGetByPhonePostError,
          MutationVariables<
            GetCustomersByPhoneEndpointAgentToolCustomerGetByPhonePostBody,
            GetCustomersByPhoneEndpointAgentToolCustomerGetByPhonePostParameters
          >,
          TContext
        >
      >;
    };
    schema: GetCustomersByPhoneEndpointAgentToolCustomerGetByPhonePostSchema;
    types: {
      parameters: GetCustomersByPhoneEndpointAgentToolCustomerGetByPhonePostParameters;
      data: GetCustomersByPhoneEndpointAgentToolCustomerGetByPhonePostData;
      error: GetCustomersByPhoneEndpointAgentToolCustomerGetByPhonePostError;
      body: GetCustomersByPhoneEndpointAgentToolCustomerGetByPhonePostBody;
    };
  };
  /**
   * @summary Get Customers By Zipcode Endpoint
   * @description Get customers by zipcode.
   *
   * Search for all customers in a specific ZIP code area.
   */
  getCustomersByZipcodeEndpointAgentToolCustomerGetByZipcodePost: {
    /**
     * @summary Get Customers By Zipcode Endpoint
     * @description Get customers by zipcode.
     *
     * Search for all customers in a specific ZIP code area.
     */
    <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(
      options: ServiceOperationMutationFnOptions<
        GetCustomersByZipcodeEndpointAgentToolCustomerGetByZipcodePostBody,
        GetCustomersByZipcodeEndpointAgentToolCustomerGetByZipcodePostParameters,
        TMeta,
        TSignal
      >,
      client?: (
        schema: GetCustomersByZipcodeEndpointAgentToolCustomerGetByZipcodePostSchema,
        options: ServiceOperationMutationFnOptions<
          GetCustomersByZipcodeEndpointAgentToolCustomerGetByZipcodePostBody,
          GetCustomersByZipcodeEndpointAgentToolCustomerGetByZipcodePostParameters,
          TMeta,
          TSignal
        >
      ) => Promise<
        RequestFnResponse<
          GetCustomersByZipcodeEndpointAgentToolCustomerGetByZipcodePostData,
          GetCustomersByZipcodeEndpointAgentToolCustomerGetByZipcodePostError
        >
      >
    ): Promise<
      RequestFnResponse<
        GetCustomersByZipcodeEndpointAgentToolCustomerGetByZipcodePostData,
        GetCustomersByZipcodeEndpointAgentToolCustomerGetByZipcodePostError
      >
    >;
    /**
     * @summary Get Customers By Zipcode Endpoint
     * @description Get customers by zipcode.
     *
     * Search for all customers in a specific ZIP code area.
     */
    getMutationKey(
      parameters: DeepReadonly<GetCustomersByZipcodeEndpointAgentToolCustomerGetByZipcodePostParameters> | void
    ): ServiceOperationMutationKey<
      GetCustomersByZipcodeEndpointAgentToolCustomerGetByZipcodePostSchema,
      GetCustomersByZipcodeEndpointAgentToolCustomerGetByZipcodePostParameters
    >;
    /**
     * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
     * Handles loading state, optimistic updates, and error handling.
     *
     * @summary Get Customers By Zipcode Endpoint
     * @description Get customers by zipcode.
     *
     * Search for all customers in a specific ZIP code area.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
     * @example Mutation with predefined parameters, e.g., for updating
     * ```ts
     * const { mutate, isPending } = qraft.agentToolsService.getCustomersByZipcodeEndpointAgentToolCustomerGetByZipcodePost.useMutation({})
     * mutate(body);
     * ```
     * @example Mutation without predefined parameters, e.g., for creating
     * ```ts
     * const { mutate, isPending } = qraft.agentToolsService.getCustomersByZipcodeEndpointAgentToolCustomerGetByZipcodePost.useMutation()
     * mutate({
     *     body: bodyPayload
     * });
     * ```
     */
    useMutation<
      TVariables extends GetCustomersByZipcodeEndpointAgentToolCustomerGetByZipcodePostBody,
      TContext = unknown,
    >(
      parameters: DeepReadonly<GetCustomersByZipcodeEndpointAgentToolCustomerGetByZipcodePostParameters>,
      options?: ServiceOperationUseMutationOptions<
        GetCustomersByZipcodeEndpointAgentToolCustomerGetByZipcodePostSchema,
        GetCustomersByZipcodeEndpointAgentToolCustomerGetByZipcodePostData,
        GetCustomersByZipcodeEndpointAgentToolCustomerGetByZipcodePostParameters,
        TVariables,
        OperationError<GetCustomersByZipcodeEndpointAgentToolCustomerGetByZipcodePostError>,
        TContext
      >
    ): UseMutationResult<
      GetCustomersByZipcodeEndpointAgentToolCustomerGetByZipcodePostData,
      OperationError<GetCustomersByZipcodeEndpointAgentToolCustomerGetByZipcodePostError>,
      TVariables,
      TContext
    >;
    /**
     * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
     * Handles loading state, optimistic updates, and error handling.
     *
     * @summary Get Customers By Zipcode Endpoint
     * @description Get customers by zipcode.
     *
     * Search for all customers in a specific ZIP code area.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
     * @example Mutation with predefined parameters, e.g., for updating
     * ```ts
     * const { mutate, isPending } = qraft.agentToolsService.getCustomersByZipcodeEndpointAgentToolCustomerGetByZipcodePost.useMutation({})
     * mutate(body);
     * ```
     * @example Mutation without predefined parameters, e.g., for creating
     * ```ts
     * const { mutate, isPending } = qraft.agentToolsService.getCustomersByZipcodeEndpointAgentToolCustomerGetByZipcodePost.useMutation()
     * mutate({
     *     body: bodyPayload
     * });
     * ```
     */
    useMutation<
      TVariables extends MutationVariables<
        GetCustomersByZipcodeEndpointAgentToolCustomerGetByZipcodePostBody,
        GetCustomersByZipcodeEndpointAgentToolCustomerGetByZipcodePostParameters
      >,
      TContext = unknown,
    >(
      parameters: void,
      options?: ServiceOperationUseMutationOptions<
        GetCustomersByZipcodeEndpointAgentToolCustomerGetByZipcodePostSchema,
        GetCustomersByZipcodeEndpointAgentToolCustomerGetByZipcodePostData,
        GetCustomersByZipcodeEndpointAgentToolCustomerGetByZipcodePostParameters,
        TVariables,
        OperationError<GetCustomersByZipcodeEndpointAgentToolCustomerGetByZipcodePostError>,
        TContext
      >
    ): UseMutationResult<
      GetCustomersByZipcodeEndpointAgentToolCustomerGetByZipcodePostData,
      OperationError<GetCustomersByZipcodeEndpointAgentToolCustomerGetByZipcodePostError>,
      TVariables,
      TContext
    >;
    /**
     * Returns the count of currently in-progress mutations.
     *
     * @summary Get Customers By Zipcode Endpoint
     * @description Get customers by zipcode.
     *
     * Search for all customers in a specific ZIP code area.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsMutating|`useIsMutating(...)` documentation}
     * @example Check how many mutations are currently in progress for the specified service method.
     * ```ts
     * const getCustomersByZipcodeEndpointAgentToolCustomerGetByZipcodePostTotal = qraft.agentToolsService.getCustomersByZipcodeEndpointAgentToolCustomerGetByZipcodePost.useIsMutating()
     * ```
     * @example Check how many mutations are currently in progress with the specified parameters.
     * ```ts
     * const getCustomersByZipcodeEndpointAgentToolCustomerGetByZipcodePostTotal = qraft.agentToolsService.getCustomersByZipcodeEndpointAgentToolCustomerGetByZipcodePost.useIsMutating({
     *     parameters: {}
     * })
     * ```
     */
    useIsMutating<TContext = unknown>(
      filters?:
        | MutationFiltersByParameters<
            GetCustomersByZipcodeEndpointAgentToolCustomerGetByZipcodePostBody,
            GetCustomersByZipcodeEndpointAgentToolCustomerGetByZipcodePostData,
            GetCustomersByZipcodeEndpointAgentToolCustomerGetByZipcodePostParameters,
            OperationError<GetCustomersByZipcodeEndpointAgentToolCustomerGetByZipcodePostError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            GetCustomersByZipcodeEndpointAgentToolCustomerGetByZipcodePostSchema,
            GetCustomersByZipcodeEndpointAgentToolCustomerGetByZipcodePostBody,
            GetCustomersByZipcodeEndpointAgentToolCustomerGetByZipcodePostData,
            GetCustomersByZipcodeEndpointAgentToolCustomerGetByZipcodePostParameters,
            OperationError<GetCustomersByZipcodeEndpointAgentToolCustomerGetByZipcodePostError>,
            TContext
          >
    ): number;
    /**
     * Provides access to the current state of a mutation, including its status, any resulting data, and associated errors.
     *
     * @summary Get Customers By Zipcode Endpoint
     * @description Get customers by zipcode.
     *
     * Search for all customers in a specific ZIP code area.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutationState|`useMutationState(...)` documentation}
     * @example Get all variables of all running mutations.
     * ```ts
     * const getCustomersByZipcodeEndpointAgentToolCustomerGetByZipcodePostPendingMutationVariables = qraft.agentToolsService.getCustomersByZipcodeEndpointAgentToolCustomerGetByZipcodePost.useMutationState({
     *     filters: {
     *         status: "pending"
     *     },
     *     select: mutation => mutation.state.variables
     * })
     * ```
     * @example Get all data for specific mutations via the `parameters`.
     * ```ts
     * const getCustomersByZipcodeEndpointAgentToolCustomerGetByZipcodePostMutationData = qraft.agentToolsService.getCustomersByZipcodeEndpointAgentToolCustomerGetByZipcodePost.useMutationState({
     *     filters: {
     *         parameters: {}
     *     },
     *     select: mutation => mutation.state.data
     * })
     * ```
     */
    useMutationState<
      TContext = unknown,
      TResult = MutationState<
        GetCustomersByZipcodeEndpointAgentToolCustomerGetByZipcodePostData,
        OperationError<GetCustomersByZipcodeEndpointAgentToolCustomerGetByZipcodePostError>,
        MutationVariables<
          GetCustomersByZipcodeEndpointAgentToolCustomerGetByZipcodePostBody,
          GetCustomersByZipcodeEndpointAgentToolCustomerGetByZipcodePostParameters
        >,
        TContext
      >,
    >(options?: {
      filters?:
        | MutationFiltersByParameters<
            GetCustomersByZipcodeEndpointAgentToolCustomerGetByZipcodePostBody,
            GetCustomersByZipcodeEndpointAgentToolCustomerGetByZipcodePostData,
            GetCustomersByZipcodeEndpointAgentToolCustomerGetByZipcodePostParameters,
            OperationError<GetCustomersByZipcodeEndpointAgentToolCustomerGetByZipcodePostError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            GetCustomersByZipcodeEndpointAgentToolCustomerGetByZipcodePostSchema,
            GetCustomersByZipcodeEndpointAgentToolCustomerGetByZipcodePostBody,
            GetCustomersByZipcodeEndpointAgentToolCustomerGetByZipcodePostData,
            GetCustomersByZipcodeEndpointAgentToolCustomerGetByZipcodePostParameters,
            OperationError<GetCustomersByZipcodeEndpointAgentToolCustomerGetByZipcodePostError>,
            TContext
          >;
      select?: (
        mutation: Mutation<
          GetCustomersByZipcodeEndpointAgentToolCustomerGetByZipcodePostData,
          OperationError<GetCustomersByZipcodeEndpointAgentToolCustomerGetByZipcodePostError>,
          MutationVariables<
            GetCustomersByZipcodeEndpointAgentToolCustomerGetByZipcodePostBody,
            GetCustomersByZipcodeEndpointAgentToolCustomerGetByZipcodePostParameters
          >,
          TContext
        >
      ) => TResult;
    }): Array<TResult>;
    /**
     * @summary Get Customers By Zipcode Endpoint
     * @description Get customers by zipcode.
     *
     * Search for all customers in a specific ZIP code area.
     */
    isMutating<TContext>(
      filters?:
        | MutationFiltersByParameters<
            GetCustomersByZipcodeEndpointAgentToolCustomerGetByZipcodePostBody,
            GetCustomersByZipcodeEndpointAgentToolCustomerGetByZipcodePostData,
            GetCustomersByZipcodeEndpointAgentToolCustomerGetByZipcodePostParameters,
            OperationError<GetCustomersByZipcodeEndpointAgentToolCustomerGetByZipcodePostError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            GetCustomersByZipcodeEndpointAgentToolCustomerGetByZipcodePostSchema,
            GetCustomersByZipcodeEndpointAgentToolCustomerGetByZipcodePostBody,
            GetCustomersByZipcodeEndpointAgentToolCustomerGetByZipcodePostData,
            GetCustomersByZipcodeEndpointAgentToolCustomerGetByZipcodePostParameters,
            OperationError<GetCustomersByZipcodeEndpointAgentToolCustomerGetByZipcodePostError>,
            TContext
          >
    ): number;
    /**
     * Returns a `MutationCache` object that provides access to mutation cache operations
     * for the specific endpoint.
     *
     * @summary Get Customers By Zipcode Endpoint
     * @description Get customers by zipcode.
     *
     * Search for all customers in a specific ZIP code area.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/query-client/getMutationCache|`getMutationCache(...)` documentation}
     *
     * @example Find a mutation with specific parameters
     * ```ts
     * const mutationCache = qraft.agentToolsService.getCustomersByZipcodeEndpointAgentToolCustomerGetByZipcodePost.getMutationCache();
     * const mutation = mutationCache.find({
     *     parameters: {}
     * });
     * ```
     *
     * @example Find all mutations for the endpoint
     * ```ts
     * const mutationCache = qraft.agentToolsService.getCustomersByZipcodeEndpointAgentToolCustomerGetByZipcodePost.getMutationCache();
     * const mutations = mutationCache.findAll();
     * ```
     */
    getMutationCache(): Omit<MutationCache, 'find' | 'findAll'> & {
      find<TContext = unknown>(
        filters:
          | MutationFiltersByParameters<
              GetCustomersByZipcodeEndpointAgentToolCustomerGetByZipcodePostBody,
              GetCustomersByZipcodeEndpointAgentToolCustomerGetByZipcodePostData,
              GetCustomersByZipcodeEndpointAgentToolCustomerGetByZipcodePostParameters,
              OperationError<GetCustomersByZipcodeEndpointAgentToolCustomerGetByZipcodePostError>,
              TContext
            >
          | MutationFiltersByMutationKey<
              GetCustomersByZipcodeEndpointAgentToolCustomerGetByZipcodePostSchema,
              GetCustomersByZipcodeEndpointAgentToolCustomerGetByZipcodePostBody,
              GetCustomersByZipcodeEndpointAgentToolCustomerGetByZipcodePostData,
              GetCustomersByZipcodeEndpointAgentToolCustomerGetByZipcodePostParameters,
              OperationError<GetCustomersByZipcodeEndpointAgentToolCustomerGetByZipcodePostError>,
              TContext
            >
      ):
        | Mutation<
            GetCustomersByZipcodeEndpointAgentToolCustomerGetByZipcodePostData,
            GetCustomersByZipcodeEndpointAgentToolCustomerGetByZipcodePostError,
            MutationVariables<
              GetCustomersByZipcodeEndpointAgentToolCustomerGetByZipcodePostBody,
              GetCustomersByZipcodeEndpointAgentToolCustomerGetByZipcodePostParameters
            >,
            TContext
          >
        | undefined;
      findAll<TContext = unknown>(
        filters?:
          | MutationFiltersByParameters<
              GetCustomersByZipcodeEndpointAgentToolCustomerGetByZipcodePostBody,
              GetCustomersByZipcodeEndpointAgentToolCustomerGetByZipcodePostData,
              GetCustomersByZipcodeEndpointAgentToolCustomerGetByZipcodePostParameters,
              OperationError<GetCustomersByZipcodeEndpointAgentToolCustomerGetByZipcodePostError>,
              TContext
            >
          | MutationFiltersByMutationKey<
              GetCustomersByZipcodeEndpointAgentToolCustomerGetByZipcodePostSchema,
              GetCustomersByZipcodeEndpointAgentToolCustomerGetByZipcodePostBody,
              GetCustomersByZipcodeEndpointAgentToolCustomerGetByZipcodePostData,
              GetCustomersByZipcodeEndpointAgentToolCustomerGetByZipcodePostParameters,
              OperationError<GetCustomersByZipcodeEndpointAgentToolCustomerGetByZipcodePostError>,
              TContext
            >
      ): Array<
        Mutation<
          GetCustomersByZipcodeEndpointAgentToolCustomerGetByZipcodePostData,
          GetCustomersByZipcodeEndpointAgentToolCustomerGetByZipcodePostError,
          MutationVariables<
            GetCustomersByZipcodeEndpointAgentToolCustomerGetByZipcodePostBody,
            GetCustomersByZipcodeEndpointAgentToolCustomerGetByZipcodePostParameters
          >,
          TContext
        >
      >;
    };
    schema: GetCustomersByZipcodeEndpointAgentToolCustomerGetByZipcodePostSchema;
    types: {
      parameters: GetCustomersByZipcodeEndpointAgentToolCustomerGetByZipcodePostParameters;
      data: GetCustomersByZipcodeEndpointAgentToolCustomerGetByZipcodePostData;
      error: GetCustomersByZipcodeEndpointAgentToolCustomerGetByZipcodePostError;
      body: GetCustomersByZipcodeEndpointAgentToolCustomerGetByZipcodePostBody;
    };
  };
  /**
   * @summary Search Customers By Address Endpoint
   * @description Search customers by address with fuzzy matching.
   *
   * Uses advanced fuzzy matching to find customers even with slight variations in address spelling.
   * Returns exact matches and similar addresses with similarity scores.
   */
  searchCustomersByAddressEndpointAgentToolCustomerSearchByAddressPost: {
    /**
     * @summary Search Customers By Address Endpoint
     * @description Search customers by address with fuzzy matching.
     *
     * Uses advanced fuzzy matching to find customers even with slight variations in address spelling.
     * Returns exact matches and similar addresses with similarity scores.
     */
    <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(
      options: ServiceOperationMutationFnOptions<
        SearchCustomersByAddressEndpointAgentToolCustomerSearchByAddressPostBody,
        SearchCustomersByAddressEndpointAgentToolCustomerSearchByAddressPostParameters,
        TMeta,
        TSignal
      >,
      client?: (
        schema: SearchCustomersByAddressEndpointAgentToolCustomerSearchByAddressPostSchema,
        options: ServiceOperationMutationFnOptions<
          SearchCustomersByAddressEndpointAgentToolCustomerSearchByAddressPostBody,
          SearchCustomersByAddressEndpointAgentToolCustomerSearchByAddressPostParameters,
          TMeta,
          TSignal
        >
      ) => Promise<
        RequestFnResponse<
          SearchCustomersByAddressEndpointAgentToolCustomerSearchByAddressPostData,
          SearchCustomersByAddressEndpointAgentToolCustomerSearchByAddressPostError
        >
      >
    ): Promise<
      RequestFnResponse<
        SearchCustomersByAddressEndpointAgentToolCustomerSearchByAddressPostData,
        SearchCustomersByAddressEndpointAgentToolCustomerSearchByAddressPostError
      >
    >;
    /**
     * @summary Search Customers By Address Endpoint
     * @description Search customers by address with fuzzy matching.
     *
     * Uses advanced fuzzy matching to find customers even with slight variations in address spelling.
     * Returns exact matches and similar addresses with similarity scores.
     */
    getMutationKey(
      parameters: DeepReadonly<SearchCustomersByAddressEndpointAgentToolCustomerSearchByAddressPostParameters> | void
    ): ServiceOperationMutationKey<
      SearchCustomersByAddressEndpointAgentToolCustomerSearchByAddressPostSchema,
      SearchCustomersByAddressEndpointAgentToolCustomerSearchByAddressPostParameters
    >;
    /**
     * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
     * Handles loading state, optimistic updates, and error handling.
     *
     * @summary Search Customers By Address Endpoint
     * @description Search customers by address with fuzzy matching.
     *
     * Uses advanced fuzzy matching to find customers even with slight variations in address spelling.
     * Returns exact matches and similar addresses with similarity scores.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
     * @example Mutation with predefined parameters, e.g., for updating
     * ```ts
     * const { mutate, isPending } = qraft.agentToolsService.searchCustomersByAddressEndpointAgentToolCustomerSearchByAddressPost.useMutation({})
     * mutate(body);
     * ```
     * @example Mutation without predefined parameters, e.g., for creating
     * ```ts
     * const { mutate, isPending } = qraft.agentToolsService.searchCustomersByAddressEndpointAgentToolCustomerSearchByAddressPost.useMutation()
     * mutate({
     *     body: bodyPayload
     * });
     * ```
     */
    useMutation<
      TVariables extends SearchCustomersByAddressEndpointAgentToolCustomerSearchByAddressPostBody,
      TContext = unknown,
    >(
      parameters: DeepReadonly<SearchCustomersByAddressEndpointAgentToolCustomerSearchByAddressPostParameters>,
      options?: ServiceOperationUseMutationOptions<
        SearchCustomersByAddressEndpointAgentToolCustomerSearchByAddressPostSchema,
        SearchCustomersByAddressEndpointAgentToolCustomerSearchByAddressPostData,
        SearchCustomersByAddressEndpointAgentToolCustomerSearchByAddressPostParameters,
        TVariables,
        OperationError<SearchCustomersByAddressEndpointAgentToolCustomerSearchByAddressPostError>,
        TContext
      >
    ): UseMutationResult<
      SearchCustomersByAddressEndpointAgentToolCustomerSearchByAddressPostData,
      OperationError<SearchCustomersByAddressEndpointAgentToolCustomerSearchByAddressPostError>,
      TVariables,
      TContext
    >;
    /**
     * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
     * Handles loading state, optimistic updates, and error handling.
     *
     * @summary Search Customers By Address Endpoint
     * @description Search customers by address with fuzzy matching.
     *
     * Uses advanced fuzzy matching to find customers even with slight variations in address spelling.
     * Returns exact matches and similar addresses with similarity scores.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
     * @example Mutation with predefined parameters, e.g., for updating
     * ```ts
     * const { mutate, isPending } = qraft.agentToolsService.searchCustomersByAddressEndpointAgentToolCustomerSearchByAddressPost.useMutation({})
     * mutate(body);
     * ```
     * @example Mutation without predefined parameters, e.g., for creating
     * ```ts
     * const { mutate, isPending } = qraft.agentToolsService.searchCustomersByAddressEndpointAgentToolCustomerSearchByAddressPost.useMutation()
     * mutate({
     *     body: bodyPayload
     * });
     * ```
     */
    useMutation<
      TVariables extends MutationVariables<
        SearchCustomersByAddressEndpointAgentToolCustomerSearchByAddressPostBody,
        SearchCustomersByAddressEndpointAgentToolCustomerSearchByAddressPostParameters
      >,
      TContext = unknown,
    >(
      parameters: void,
      options?: ServiceOperationUseMutationOptions<
        SearchCustomersByAddressEndpointAgentToolCustomerSearchByAddressPostSchema,
        SearchCustomersByAddressEndpointAgentToolCustomerSearchByAddressPostData,
        SearchCustomersByAddressEndpointAgentToolCustomerSearchByAddressPostParameters,
        TVariables,
        OperationError<SearchCustomersByAddressEndpointAgentToolCustomerSearchByAddressPostError>,
        TContext
      >
    ): UseMutationResult<
      SearchCustomersByAddressEndpointAgentToolCustomerSearchByAddressPostData,
      OperationError<SearchCustomersByAddressEndpointAgentToolCustomerSearchByAddressPostError>,
      TVariables,
      TContext
    >;
    /**
     * Returns the count of currently in-progress mutations.
     *
     * @summary Search Customers By Address Endpoint
     * @description Search customers by address with fuzzy matching.
     *
     * Uses advanced fuzzy matching to find customers even with slight variations in address spelling.
     * Returns exact matches and similar addresses with similarity scores.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsMutating|`useIsMutating(...)` documentation}
     * @example Check how many mutations are currently in progress for the specified service method.
     * ```ts
     * const searchCustomersByAddressEndpointAgentToolCustomerSearchByAddressPostTotal = qraft.agentToolsService.searchCustomersByAddressEndpointAgentToolCustomerSearchByAddressPost.useIsMutating()
     * ```
     * @example Check how many mutations are currently in progress with the specified parameters.
     * ```ts
     * const searchCustomersByAddressEndpointAgentToolCustomerSearchByAddressPostTotal = qraft.agentToolsService.searchCustomersByAddressEndpointAgentToolCustomerSearchByAddressPost.useIsMutating({
     *     parameters: {}
     * })
     * ```
     */
    useIsMutating<TContext = unknown>(
      filters?:
        | MutationFiltersByParameters<
            SearchCustomersByAddressEndpointAgentToolCustomerSearchByAddressPostBody,
            SearchCustomersByAddressEndpointAgentToolCustomerSearchByAddressPostData,
            SearchCustomersByAddressEndpointAgentToolCustomerSearchByAddressPostParameters,
            OperationError<SearchCustomersByAddressEndpointAgentToolCustomerSearchByAddressPostError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            SearchCustomersByAddressEndpointAgentToolCustomerSearchByAddressPostSchema,
            SearchCustomersByAddressEndpointAgentToolCustomerSearchByAddressPostBody,
            SearchCustomersByAddressEndpointAgentToolCustomerSearchByAddressPostData,
            SearchCustomersByAddressEndpointAgentToolCustomerSearchByAddressPostParameters,
            OperationError<SearchCustomersByAddressEndpointAgentToolCustomerSearchByAddressPostError>,
            TContext
          >
    ): number;
    /**
     * Provides access to the current state of a mutation, including its status, any resulting data, and associated errors.
     *
     * @summary Search Customers By Address Endpoint
     * @description Search customers by address with fuzzy matching.
     *
     * Uses advanced fuzzy matching to find customers even with slight variations in address spelling.
     * Returns exact matches and similar addresses with similarity scores.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutationState|`useMutationState(...)` documentation}
     * @example Get all variables of all running mutations.
     * ```ts
     * const searchCustomersByAddressEndpointAgentToolCustomerSearchByAddressPostPendingMutationVariables = qraft.agentToolsService.searchCustomersByAddressEndpointAgentToolCustomerSearchByAddressPost.useMutationState({
     *     filters: {
     *         status: "pending"
     *     },
     *     select: mutation => mutation.state.variables
     * })
     * ```
     * @example Get all data for specific mutations via the `parameters`.
     * ```ts
     * const searchCustomersByAddressEndpointAgentToolCustomerSearchByAddressPostMutationData = qraft.agentToolsService.searchCustomersByAddressEndpointAgentToolCustomerSearchByAddressPost.useMutationState({
     *     filters: {
     *         parameters: {}
     *     },
     *     select: mutation => mutation.state.data
     * })
     * ```
     */
    useMutationState<
      TContext = unknown,
      TResult = MutationState<
        SearchCustomersByAddressEndpointAgentToolCustomerSearchByAddressPostData,
        OperationError<SearchCustomersByAddressEndpointAgentToolCustomerSearchByAddressPostError>,
        MutationVariables<
          SearchCustomersByAddressEndpointAgentToolCustomerSearchByAddressPostBody,
          SearchCustomersByAddressEndpointAgentToolCustomerSearchByAddressPostParameters
        >,
        TContext
      >,
    >(options?: {
      filters?:
        | MutationFiltersByParameters<
            SearchCustomersByAddressEndpointAgentToolCustomerSearchByAddressPostBody,
            SearchCustomersByAddressEndpointAgentToolCustomerSearchByAddressPostData,
            SearchCustomersByAddressEndpointAgentToolCustomerSearchByAddressPostParameters,
            OperationError<SearchCustomersByAddressEndpointAgentToolCustomerSearchByAddressPostError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            SearchCustomersByAddressEndpointAgentToolCustomerSearchByAddressPostSchema,
            SearchCustomersByAddressEndpointAgentToolCustomerSearchByAddressPostBody,
            SearchCustomersByAddressEndpointAgentToolCustomerSearchByAddressPostData,
            SearchCustomersByAddressEndpointAgentToolCustomerSearchByAddressPostParameters,
            OperationError<SearchCustomersByAddressEndpointAgentToolCustomerSearchByAddressPostError>,
            TContext
          >;
      select?: (
        mutation: Mutation<
          SearchCustomersByAddressEndpointAgentToolCustomerSearchByAddressPostData,
          OperationError<SearchCustomersByAddressEndpointAgentToolCustomerSearchByAddressPostError>,
          MutationVariables<
            SearchCustomersByAddressEndpointAgentToolCustomerSearchByAddressPostBody,
            SearchCustomersByAddressEndpointAgentToolCustomerSearchByAddressPostParameters
          >,
          TContext
        >
      ) => TResult;
    }): Array<TResult>;
    /**
     * @summary Search Customers By Address Endpoint
     * @description Search customers by address with fuzzy matching.
     *
     * Uses advanced fuzzy matching to find customers even with slight variations in address spelling.
     * Returns exact matches and similar addresses with similarity scores.
     */
    isMutating<TContext>(
      filters?:
        | MutationFiltersByParameters<
            SearchCustomersByAddressEndpointAgentToolCustomerSearchByAddressPostBody,
            SearchCustomersByAddressEndpointAgentToolCustomerSearchByAddressPostData,
            SearchCustomersByAddressEndpointAgentToolCustomerSearchByAddressPostParameters,
            OperationError<SearchCustomersByAddressEndpointAgentToolCustomerSearchByAddressPostError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            SearchCustomersByAddressEndpointAgentToolCustomerSearchByAddressPostSchema,
            SearchCustomersByAddressEndpointAgentToolCustomerSearchByAddressPostBody,
            SearchCustomersByAddressEndpointAgentToolCustomerSearchByAddressPostData,
            SearchCustomersByAddressEndpointAgentToolCustomerSearchByAddressPostParameters,
            OperationError<SearchCustomersByAddressEndpointAgentToolCustomerSearchByAddressPostError>,
            TContext
          >
    ): number;
    /**
     * Returns a `MutationCache` object that provides access to mutation cache operations
     * for the specific endpoint.
     *
     * @summary Search Customers By Address Endpoint
     * @description Search customers by address with fuzzy matching.
     *
     * Uses advanced fuzzy matching to find customers even with slight variations in address spelling.
     * Returns exact matches and similar addresses with similarity scores.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/query-client/getMutationCache|`getMutationCache(...)` documentation}
     *
     * @example Find a mutation with specific parameters
     * ```ts
     * const mutationCache = qraft.agentToolsService.searchCustomersByAddressEndpointAgentToolCustomerSearchByAddressPost.getMutationCache();
     * const mutation = mutationCache.find({
     *     parameters: {}
     * });
     * ```
     *
     * @example Find all mutations for the endpoint
     * ```ts
     * const mutationCache = qraft.agentToolsService.searchCustomersByAddressEndpointAgentToolCustomerSearchByAddressPost.getMutationCache();
     * const mutations = mutationCache.findAll();
     * ```
     */
    getMutationCache(): Omit<MutationCache, 'find' | 'findAll'> & {
      find<TContext = unknown>(
        filters:
          | MutationFiltersByParameters<
              SearchCustomersByAddressEndpointAgentToolCustomerSearchByAddressPostBody,
              SearchCustomersByAddressEndpointAgentToolCustomerSearchByAddressPostData,
              SearchCustomersByAddressEndpointAgentToolCustomerSearchByAddressPostParameters,
              OperationError<SearchCustomersByAddressEndpointAgentToolCustomerSearchByAddressPostError>,
              TContext
            >
          | MutationFiltersByMutationKey<
              SearchCustomersByAddressEndpointAgentToolCustomerSearchByAddressPostSchema,
              SearchCustomersByAddressEndpointAgentToolCustomerSearchByAddressPostBody,
              SearchCustomersByAddressEndpointAgentToolCustomerSearchByAddressPostData,
              SearchCustomersByAddressEndpointAgentToolCustomerSearchByAddressPostParameters,
              OperationError<SearchCustomersByAddressEndpointAgentToolCustomerSearchByAddressPostError>,
              TContext
            >
      ):
        | Mutation<
            SearchCustomersByAddressEndpointAgentToolCustomerSearchByAddressPostData,
            SearchCustomersByAddressEndpointAgentToolCustomerSearchByAddressPostError,
            MutationVariables<
              SearchCustomersByAddressEndpointAgentToolCustomerSearchByAddressPostBody,
              SearchCustomersByAddressEndpointAgentToolCustomerSearchByAddressPostParameters
            >,
            TContext
          >
        | undefined;
      findAll<TContext = unknown>(
        filters?:
          | MutationFiltersByParameters<
              SearchCustomersByAddressEndpointAgentToolCustomerSearchByAddressPostBody,
              SearchCustomersByAddressEndpointAgentToolCustomerSearchByAddressPostData,
              SearchCustomersByAddressEndpointAgentToolCustomerSearchByAddressPostParameters,
              OperationError<SearchCustomersByAddressEndpointAgentToolCustomerSearchByAddressPostError>,
              TContext
            >
          | MutationFiltersByMutationKey<
              SearchCustomersByAddressEndpointAgentToolCustomerSearchByAddressPostSchema,
              SearchCustomersByAddressEndpointAgentToolCustomerSearchByAddressPostBody,
              SearchCustomersByAddressEndpointAgentToolCustomerSearchByAddressPostData,
              SearchCustomersByAddressEndpointAgentToolCustomerSearchByAddressPostParameters,
              OperationError<SearchCustomersByAddressEndpointAgentToolCustomerSearchByAddressPostError>,
              TContext
            >
      ): Array<
        Mutation<
          SearchCustomersByAddressEndpointAgentToolCustomerSearchByAddressPostData,
          SearchCustomersByAddressEndpointAgentToolCustomerSearchByAddressPostError,
          MutationVariables<
            SearchCustomersByAddressEndpointAgentToolCustomerSearchByAddressPostBody,
            SearchCustomersByAddressEndpointAgentToolCustomerSearchByAddressPostParameters
          >,
          TContext
        >
      >;
    };
    schema: SearchCustomersByAddressEndpointAgentToolCustomerSearchByAddressPostSchema;
    types: {
      parameters: SearchCustomersByAddressEndpointAgentToolCustomerSearchByAddressPostParameters;
      data: SearchCustomersByAddressEndpointAgentToolCustomerSearchByAddressPostData;
      error: SearchCustomersByAddressEndpointAgentToolCustomerSearchByAddressPostError;
      body: SearchCustomersByAddressEndpointAgentToolCustomerSearchByAddressPostBody;
    };
  };
  /**
   * @summary Create Customer Endpoint
   * @description Create a new customer.
   *
   * Creates a new customer with contact information and optional address.
   */
  createCustomerEndpointAgentToolCustomerCreatePost: {
    /**
     * @summary Create Customer Endpoint
     * @description Create a new customer.
     *
     * Creates a new customer with contact information and optional address.
     */
    <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(
      options: ServiceOperationMutationFnOptions<
        CreateCustomerEndpointAgentToolCustomerCreatePostBody,
        CreateCustomerEndpointAgentToolCustomerCreatePostParameters,
        TMeta,
        TSignal
      >,
      client?: (
        schema: CreateCustomerEndpointAgentToolCustomerCreatePostSchema,
        options: ServiceOperationMutationFnOptions<
          CreateCustomerEndpointAgentToolCustomerCreatePostBody,
          CreateCustomerEndpointAgentToolCustomerCreatePostParameters,
          TMeta,
          TSignal
        >
      ) => Promise<
        RequestFnResponse<
          CreateCustomerEndpointAgentToolCustomerCreatePostData,
          CreateCustomerEndpointAgentToolCustomerCreatePostError
        >
      >
    ): Promise<
      RequestFnResponse<
        CreateCustomerEndpointAgentToolCustomerCreatePostData,
        CreateCustomerEndpointAgentToolCustomerCreatePostError
      >
    >;
    /**
     * @summary Create Customer Endpoint
     * @description Create a new customer.
     *
     * Creates a new customer with contact information and optional address.
     */
    getMutationKey(
      parameters: DeepReadonly<CreateCustomerEndpointAgentToolCustomerCreatePostParameters> | void
    ): ServiceOperationMutationKey<
      CreateCustomerEndpointAgentToolCustomerCreatePostSchema,
      CreateCustomerEndpointAgentToolCustomerCreatePostParameters
    >;
    /**
     * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
     * Handles loading state, optimistic updates, and error handling.
     *
     * @summary Create Customer Endpoint
     * @description Create a new customer.
     *
     * Creates a new customer with contact information and optional address.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
     * @example Mutation with predefined parameters, e.g., for updating
     * ```ts
     * const { mutate, isPending } = qraft.agentToolsService.createCustomerEndpointAgentToolCustomerCreatePost.useMutation({})
     * mutate(body);
     * ```
     * @example Mutation without predefined parameters, e.g., for creating
     * ```ts
     * const { mutate, isPending } = qraft.agentToolsService.createCustomerEndpointAgentToolCustomerCreatePost.useMutation()
     * mutate({
     *     body: bodyPayload
     * });
     * ```
     */
    useMutation<TVariables extends CreateCustomerEndpointAgentToolCustomerCreatePostBody, TContext = unknown>(
      parameters: DeepReadonly<CreateCustomerEndpointAgentToolCustomerCreatePostParameters>,
      options?: ServiceOperationUseMutationOptions<
        CreateCustomerEndpointAgentToolCustomerCreatePostSchema,
        CreateCustomerEndpointAgentToolCustomerCreatePostData,
        CreateCustomerEndpointAgentToolCustomerCreatePostParameters,
        TVariables,
        OperationError<CreateCustomerEndpointAgentToolCustomerCreatePostError>,
        TContext
      >
    ): UseMutationResult<
      CreateCustomerEndpointAgentToolCustomerCreatePostData,
      OperationError<CreateCustomerEndpointAgentToolCustomerCreatePostError>,
      TVariables,
      TContext
    >;
    /**
     * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
     * Handles loading state, optimistic updates, and error handling.
     *
     * @summary Create Customer Endpoint
     * @description Create a new customer.
     *
     * Creates a new customer with contact information and optional address.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
     * @example Mutation with predefined parameters, e.g., for updating
     * ```ts
     * const { mutate, isPending } = qraft.agentToolsService.createCustomerEndpointAgentToolCustomerCreatePost.useMutation({})
     * mutate(body);
     * ```
     * @example Mutation without predefined parameters, e.g., for creating
     * ```ts
     * const { mutate, isPending } = qraft.agentToolsService.createCustomerEndpointAgentToolCustomerCreatePost.useMutation()
     * mutate({
     *     body: bodyPayload
     * });
     * ```
     */
    useMutation<
      TVariables extends MutationVariables<
        CreateCustomerEndpointAgentToolCustomerCreatePostBody,
        CreateCustomerEndpointAgentToolCustomerCreatePostParameters
      >,
      TContext = unknown,
    >(
      parameters: void,
      options?: ServiceOperationUseMutationOptions<
        CreateCustomerEndpointAgentToolCustomerCreatePostSchema,
        CreateCustomerEndpointAgentToolCustomerCreatePostData,
        CreateCustomerEndpointAgentToolCustomerCreatePostParameters,
        TVariables,
        OperationError<CreateCustomerEndpointAgentToolCustomerCreatePostError>,
        TContext
      >
    ): UseMutationResult<
      CreateCustomerEndpointAgentToolCustomerCreatePostData,
      OperationError<CreateCustomerEndpointAgentToolCustomerCreatePostError>,
      TVariables,
      TContext
    >;
    /**
     * Returns the count of currently in-progress mutations.
     *
     * @summary Create Customer Endpoint
     * @description Create a new customer.
     *
     * Creates a new customer with contact information and optional address.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsMutating|`useIsMutating(...)` documentation}
     * @example Check how many mutations are currently in progress for the specified service method.
     * ```ts
     * const createCustomerEndpointAgentToolCustomerCreatePostTotal = qraft.agentToolsService.createCustomerEndpointAgentToolCustomerCreatePost.useIsMutating()
     * ```
     * @example Check how many mutations are currently in progress with the specified parameters.
     * ```ts
     * const createCustomerEndpointAgentToolCustomerCreatePostTotal = qraft.agentToolsService.createCustomerEndpointAgentToolCustomerCreatePost.useIsMutating({
     *     parameters: {}
     * })
     * ```
     */
    useIsMutating<TContext = unknown>(
      filters?:
        | MutationFiltersByParameters<
            CreateCustomerEndpointAgentToolCustomerCreatePostBody,
            CreateCustomerEndpointAgentToolCustomerCreatePostData,
            CreateCustomerEndpointAgentToolCustomerCreatePostParameters,
            OperationError<CreateCustomerEndpointAgentToolCustomerCreatePostError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            CreateCustomerEndpointAgentToolCustomerCreatePostSchema,
            CreateCustomerEndpointAgentToolCustomerCreatePostBody,
            CreateCustomerEndpointAgentToolCustomerCreatePostData,
            CreateCustomerEndpointAgentToolCustomerCreatePostParameters,
            OperationError<CreateCustomerEndpointAgentToolCustomerCreatePostError>,
            TContext
          >
    ): number;
    /**
     * Provides access to the current state of a mutation, including its status, any resulting data, and associated errors.
     *
     * @summary Create Customer Endpoint
     * @description Create a new customer.
     *
     * Creates a new customer with contact information and optional address.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutationState|`useMutationState(...)` documentation}
     * @example Get all variables of all running mutations.
     * ```ts
     * const createCustomerEndpointAgentToolCustomerCreatePostPendingMutationVariables = qraft.agentToolsService.createCustomerEndpointAgentToolCustomerCreatePost.useMutationState({
     *     filters: {
     *         status: "pending"
     *     },
     *     select: mutation => mutation.state.variables
     * })
     * ```
     * @example Get all data for specific mutations via the `parameters`.
     * ```ts
     * const createCustomerEndpointAgentToolCustomerCreatePostMutationData = qraft.agentToolsService.createCustomerEndpointAgentToolCustomerCreatePost.useMutationState({
     *     filters: {
     *         parameters: {}
     *     },
     *     select: mutation => mutation.state.data
     * })
     * ```
     */
    useMutationState<
      TContext = unknown,
      TResult = MutationState<
        CreateCustomerEndpointAgentToolCustomerCreatePostData,
        OperationError<CreateCustomerEndpointAgentToolCustomerCreatePostError>,
        MutationVariables<
          CreateCustomerEndpointAgentToolCustomerCreatePostBody,
          CreateCustomerEndpointAgentToolCustomerCreatePostParameters
        >,
        TContext
      >,
    >(options?: {
      filters?:
        | MutationFiltersByParameters<
            CreateCustomerEndpointAgentToolCustomerCreatePostBody,
            CreateCustomerEndpointAgentToolCustomerCreatePostData,
            CreateCustomerEndpointAgentToolCustomerCreatePostParameters,
            OperationError<CreateCustomerEndpointAgentToolCustomerCreatePostError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            CreateCustomerEndpointAgentToolCustomerCreatePostSchema,
            CreateCustomerEndpointAgentToolCustomerCreatePostBody,
            CreateCustomerEndpointAgentToolCustomerCreatePostData,
            CreateCustomerEndpointAgentToolCustomerCreatePostParameters,
            OperationError<CreateCustomerEndpointAgentToolCustomerCreatePostError>,
            TContext
          >;
      select?: (
        mutation: Mutation<
          CreateCustomerEndpointAgentToolCustomerCreatePostData,
          OperationError<CreateCustomerEndpointAgentToolCustomerCreatePostError>,
          MutationVariables<
            CreateCustomerEndpointAgentToolCustomerCreatePostBody,
            CreateCustomerEndpointAgentToolCustomerCreatePostParameters
          >,
          TContext
        >
      ) => TResult;
    }): Array<TResult>;
    /**
     * @summary Create Customer Endpoint
     * @description Create a new customer.
     *
     * Creates a new customer with contact information and optional address.
     */
    isMutating<TContext>(
      filters?:
        | MutationFiltersByParameters<
            CreateCustomerEndpointAgentToolCustomerCreatePostBody,
            CreateCustomerEndpointAgentToolCustomerCreatePostData,
            CreateCustomerEndpointAgentToolCustomerCreatePostParameters,
            OperationError<CreateCustomerEndpointAgentToolCustomerCreatePostError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            CreateCustomerEndpointAgentToolCustomerCreatePostSchema,
            CreateCustomerEndpointAgentToolCustomerCreatePostBody,
            CreateCustomerEndpointAgentToolCustomerCreatePostData,
            CreateCustomerEndpointAgentToolCustomerCreatePostParameters,
            OperationError<CreateCustomerEndpointAgentToolCustomerCreatePostError>,
            TContext
          >
    ): number;
    /**
     * Returns a `MutationCache` object that provides access to mutation cache operations
     * for the specific endpoint.
     *
     * @summary Create Customer Endpoint
     * @description Create a new customer.
     *
     * Creates a new customer with contact information and optional address.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/query-client/getMutationCache|`getMutationCache(...)` documentation}
     *
     * @example Find a mutation with specific parameters
     * ```ts
     * const mutationCache = qraft.agentToolsService.createCustomerEndpointAgentToolCustomerCreatePost.getMutationCache();
     * const mutation = mutationCache.find({
     *     parameters: {}
     * });
     * ```
     *
     * @example Find all mutations for the endpoint
     * ```ts
     * const mutationCache = qraft.agentToolsService.createCustomerEndpointAgentToolCustomerCreatePost.getMutationCache();
     * const mutations = mutationCache.findAll();
     * ```
     */
    getMutationCache(): Omit<MutationCache, 'find' | 'findAll'> & {
      find<TContext = unknown>(
        filters:
          | MutationFiltersByParameters<
              CreateCustomerEndpointAgentToolCustomerCreatePostBody,
              CreateCustomerEndpointAgentToolCustomerCreatePostData,
              CreateCustomerEndpointAgentToolCustomerCreatePostParameters,
              OperationError<CreateCustomerEndpointAgentToolCustomerCreatePostError>,
              TContext
            >
          | MutationFiltersByMutationKey<
              CreateCustomerEndpointAgentToolCustomerCreatePostSchema,
              CreateCustomerEndpointAgentToolCustomerCreatePostBody,
              CreateCustomerEndpointAgentToolCustomerCreatePostData,
              CreateCustomerEndpointAgentToolCustomerCreatePostParameters,
              OperationError<CreateCustomerEndpointAgentToolCustomerCreatePostError>,
              TContext
            >
      ):
        | Mutation<
            CreateCustomerEndpointAgentToolCustomerCreatePostData,
            CreateCustomerEndpointAgentToolCustomerCreatePostError,
            MutationVariables<
              CreateCustomerEndpointAgentToolCustomerCreatePostBody,
              CreateCustomerEndpointAgentToolCustomerCreatePostParameters
            >,
            TContext
          >
        | undefined;
      findAll<TContext = unknown>(
        filters?:
          | MutationFiltersByParameters<
              CreateCustomerEndpointAgentToolCustomerCreatePostBody,
              CreateCustomerEndpointAgentToolCustomerCreatePostData,
              CreateCustomerEndpointAgentToolCustomerCreatePostParameters,
              OperationError<CreateCustomerEndpointAgentToolCustomerCreatePostError>,
              TContext
            >
          | MutationFiltersByMutationKey<
              CreateCustomerEndpointAgentToolCustomerCreatePostSchema,
              CreateCustomerEndpointAgentToolCustomerCreatePostBody,
              CreateCustomerEndpointAgentToolCustomerCreatePostData,
              CreateCustomerEndpointAgentToolCustomerCreatePostParameters,
              OperationError<CreateCustomerEndpointAgentToolCustomerCreatePostError>,
              TContext
            >
      ): Array<
        Mutation<
          CreateCustomerEndpointAgentToolCustomerCreatePostData,
          CreateCustomerEndpointAgentToolCustomerCreatePostError,
          MutationVariables<
            CreateCustomerEndpointAgentToolCustomerCreatePostBody,
            CreateCustomerEndpointAgentToolCustomerCreatePostParameters
          >,
          TContext
        >
      >;
    };
    schema: CreateCustomerEndpointAgentToolCustomerCreatePostSchema;
    types: {
      parameters: CreateCustomerEndpointAgentToolCustomerCreatePostParameters;
      data: CreateCustomerEndpointAgentToolCustomerCreatePostData;
      error: CreateCustomerEndpointAgentToolCustomerCreatePostError;
      body: CreateCustomerEndpointAgentToolCustomerCreatePostBody;
    };
  };
  /**
   * @summary Get Availability Endpoint
   * @description Get available appointment slots for a customer and service type.
   */
  getAvailabilityEndpointAgentToolAvailabilityListPost: {
    /**
     * @summary Get Availability Endpoint
     * @description Get available appointment slots for a customer and service type.
     */
    <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(
      options: ServiceOperationMutationFnOptions<
        GetAvailabilityEndpointAgentToolAvailabilityListPostBody,
        GetAvailabilityEndpointAgentToolAvailabilityListPostParameters,
        TMeta,
        TSignal
      >,
      client?: (
        schema: GetAvailabilityEndpointAgentToolAvailabilityListPostSchema,
        options: ServiceOperationMutationFnOptions<
          GetAvailabilityEndpointAgentToolAvailabilityListPostBody,
          GetAvailabilityEndpointAgentToolAvailabilityListPostParameters,
          TMeta,
          TSignal
        >
      ) => Promise<
        RequestFnResponse<
          GetAvailabilityEndpointAgentToolAvailabilityListPostData,
          GetAvailabilityEndpointAgentToolAvailabilityListPostError
        >
      >
    ): Promise<
      RequestFnResponse<
        GetAvailabilityEndpointAgentToolAvailabilityListPostData,
        GetAvailabilityEndpointAgentToolAvailabilityListPostError
      >
    >;
    /**
     * @summary Get Availability Endpoint
     * @description Get available appointment slots for a customer and service type.
     */
    getMutationKey(
      parameters: DeepReadonly<GetAvailabilityEndpointAgentToolAvailabilityListPostParameters> | void
    ): ServiceOperationMutationKey<
      GetAvailabilityEndpointAgentToolAvailabilityListPostSchema,
      GetAvailabilityEndpointAgentToolAvailabilityListPostParameters
    >;
    /**
     * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
     * Handles loading state, optimistic updates, and error handling.
     *
     * @summary Get Availability Endpoint
     * @description Get available appointment slots for a customer and service type.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
     * @example Mutation with predefined parameters, e.g., for updating
     * ```ts
     * const { mutate, isPending } = qraft.agentToolsService.getAvailabilityEndpointAgentToolAvailabilityListPost.useMutation({})
     * mutate(body);
     * ```
     * @example Mutation without predefined parameters, e.g., for creating
     * ```ts
     * const { mutate, isPending } = qraft.agentToolsService.getAvailabilityEndpointAgentToolAvailabilityListPost.useMutation()
     * mutate({
     *     body: bodyPayload
     * });
     * ```
     */
    useMutation<TVariables extends GetAvailabilityEndpointAgentToolAvailabilityListPostBody, TContext = unknown>(
      parameters: DeepReadonly<GetAvailabilityEndpointAgentToolAvailabilityListPostParameters>,
      options?: ServiceOperationUseMutationOptions<
        GetAvailabilityEndpointAgentToolAvailabilityListPostSchema,
        GetAvailabilityEndpointAgentToolAvailabilityListPostData,
        GetAvailabilityEndpointAgentToolAvailabilityListPostParameters,
        TVariables,
        OperationError<GetAvailabilityEndpointAgentToolAvailabilityListPostError>,
        TContext
      >
    ): UseMutationResult<
      GetAvailabilityEndpointAgentToolAvailabilityListPostData,
      OperationError<GetAvailabilityEndpointAgentToolAvailabilityListPostError>,
      TVariables,
      TContext
    >;
    /**
     * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
     * Handles loading state, optimistic updates, and error handling.
     *
     * @summary Get Availability Endpoint
     * @description Get available appointment slots for a customer and service type.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
     * @example Mutation with predefined parameters, e.g., for updating
     * ```ts
     * const { mutate, isPending } = qraft.agentToolsService.getAvailabilityEndpointAgentToolAvailabilityListPost.useMutation({})
     * mutate(body);
     * ```
     * @example Mutation without predefined parameters, e.g., for creating
     * ```ts
     * const { mutate, isPending } = qraft.agentToolsService.getAvailabilityEndpointAgentToolAvailabilityListPost.useMutation()
     * mutate({
     *     body: bodyPayload
     * });
     * ```
     */
    useMutation<
      TVariables extends MutationVariables<
        GetAvailabilityEndpointAgentToolAvailabilityListPostBody,
        GetAvailabilityEndpointAgentToolAvailabilityListPostParameters
      >,
      TContext = unknown,
    >(
      parameters: void,
      options?: ServiceOperationUseMutationOptions<
        GetAvailabilityEndpointAgentToolAvailabilityListPostSchema,
        GetAvailabilityEndpointAgentToolAvailabilityListPostData,
        GetAvailabilityEndpointAgentToolAvailabilityListPostParameters,
        TVariables,
        OperationError<GetAvailabilityEndpointAgentToolAvailabilityListPostError>,
        TContext
      >
    ): UseMutationResult<
      GetAvailabilityEndpointAgentToolAvailabilityListPostData,
      OperationError<GetAvailabilityEndpointAgentToolAvailabilityListPostError>,
      TVariables,
      TContext
    >;
    /**
     * Returns the count of currently in-progress mutations.
     *
     * @summary Get Availability Endpoint
     * @description Get available appointment slots for a customer and service type.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsMutating|`useIsMutating(...)` documentation}
     * @example Check how many mutations are currently in progress for the specified service method.
     * ```ts
     * const getAvailabilityEndpointAgentToolAvailabilityListPostTotal = qraft.agentToolsService.getAvailabilityEndpointAgentToolAvailabilityListPost.useIsMutating()
     * ```
     * @example Check how many mutations are currently in progress with the specified parameters.
     * ```ts
     * const getAvailabilityEndpointAgentToolAvailabilityListPostTotal = qraft.agentToolsService.getAvailabilityEndpointAgentToolAvailabilityListPost.useIsMutating({
     *     parameters: {}
     * })
     * ```
     */
    useIsMutating<TContext = unknown>(
      filters?:
        | MutationFiltersByParameters<
            GetAvailabilityEndpointAgentToolAvailabilityListPostBody,
            GetAvailabilityEndpointAgentToolAvailabilityListPostData,
            GetAvailabilityEndpointAgentToolAvailabilityListPostParameters,
            OperationError<GetAvailabilityEndpointAgentToolAvailabilityListPostError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            GetAvailabilityEndpointAgentToolAvailabilityListPostSchema,
            GetAvailabilityEndpointAgentToolAvailabilityListPostBody,
            GetAvailabilityEndpointAgentToolAvailabilityListPostData,
            GetAvailabilityEndpointAgentToolAvailabilityListPostParameters,
            OperationError<GetAvailabilityEndpointAgentToolAvailabilityListPostError>,
            TContext
          >
    ): number;
    /**
     * Provides access to the current state of a mutation, including its status, any resulting data, and associated errors.
     *
     * @summary Get Availability Endpoint
     * @description Get available appointment slots for a customer and service type.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutationState|`useMutationState(...)` documentation}
     * @example Get all variables of all running mutations.
     * ```ts
     * const getAvailabilityEndpointAgentToolAvailabilityListPostPendingMutationVariables = qraft.agentToolsService.getAvailabilityEndpointAgentToolAvailabilityListPost.useMutationState({
     *     filters: {
     *         status: "pending"
     *     },
     *     select: mutation => mutation.state.variables
     * })
     * ```
     * @example Get all data for specific mutations via the `parameters`.
     * ```ts
     * const getAvailabilityEndpointAgentToolAvailabilityListPostMutationData = qraft.agentToolsService.getAvailabilityEndpointAgentToolAvailabilityListPost.useMutationState({
     *     filters: {
     *         parameters: {}
     *     },
     *     select: mutation => mutation.state.data
     * })
     * ```
     */
    useMutationState<
      TContext = unknown,
      TResult = MutationState<
        GetAvailabilityEndpointAgentToolAvailabilityListPostData,
        OperationError<GetAvailabilityEndpointAgentToolAvailabilityListPostError>,
        MutationVariables<
          GetAvailabilityEndpointAgentToolAvailabilityListPostBody,
          GetAvailabilityEndpointAgentToolAvailabilityListPostParameters
        >,
        TContext
      >,
    >(options?: {
      filters?:
        | MutationFiltersByParameters<
            GetAvailabilityEndpointAgentToolAvailabilityListPostBody,
            GetAvailabilityEndpointAgentToolAvailabilityListPostData,
            GetAvailabilityEndpointAgentToolAvailabilityListPostParameters,
            OperationError<GetAvailabilityEndpointAgentToolAvailabilityListPostError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            GetAvailabilityEndpointAgentToolAvailabilityListPostSchema,
            GetAvailabilityEndpointAgentToolAvailabilityListPostBody,
            GetAvailabilityEndpointAgentToolAvailabilityListPostData,
            GetAvailabilityEndpointAgentToolAvailabilityListPostParameters,
            OperationError<GetAvailabilityEndpointAgentToolAvailabilityListPostError>,
            TContext
          >;
      select?: (
        mutation: Mutation<
          GetAvailabilityEndpointAgentToolAvailabilityListPostData,
          OperationError<GetAvailabilityEndpointAgentToolAvailabilityListPostError>,
          MutationVariables<
            GetAvailabilityEndpointAgentToolAvailabilityListPostBody,
            GetAvailabilityEndpointAgentToolAvailabilityListPostParameters
          >,
          TContext
        >
      ) => TResult;
    }): Array<TResult>;
    /**
     * @summary Get Availability Endpoint
     * @description Get available appointment slots for a customer and service type.
     */
    isMutating<TContext>(
      filters?:
        | MutationFiltersByParameters<
            GetAvailabilityEndpointAgentToolAvailabilityListPostBody,
            GetAvailabilityEndpointAgentToolAvailabilityListPostData,
            GetAvailabilityEndpointAgentToolAvailabilityListPostParameters,
            OperationError<GetAvailabilityEndpointAgentToolAvailabilityListPostError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            GetAvailabilityEndpointAgentToolAvailabilityListPostSchema,
            GetAvailabilityEndpointAgentToolAvailabilityListPostBody,
            GetAvailabilityEndpointAgentToolAvailabilityListPostData,
            GetAvailabilityEndpointAgentToolAvailabilityListPostParameters,
            OperationError<GetAvailabilityEndpointAgentToolAvailabilityListPostError>,
            TContext
          >
    ): number;
    /**
     * Returns a `MutationCache` object that provides access to mutation cache operations
     * for the specific endpoint.
     *
     * @summary Get Availability Endpoint
     * @description Get available appointment slots for a customer and service type.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/query-client/getMutationCache|`getMutationCache(...)` documentation}
     *
     * @example Find a mutation with specific parameters
     * ```ts
     * const mutationCache = qraft.agentToolsService.getAvailabilityEndpointAgentToolAvailabilityListPost.getMutationCache();
     * const mutation = mutationCache.find({
     *     parameters: {}
     * });
     * ```
     *
     * @example Find all mutations for the endpoint
     * ```ts
     * const mutationCache = qraft.agentToolsService.getAvailabilityEndpointAgentToolAvailabilityListPost.getMutationCache();
     * const mutations = mutationCache.findAll();
     * ```
     */
    getMutationCache(): Omit<MutationCache, 'find' | 'findAll'> & {
      find<TContext = unknown>(
        filters:
          | MutationFiltersByParameters<
              GetAvailabilityEndpointAgentToolAvailabilityListPostBody,
              GetAvailabilityEndpointAgentToolAvailabilityListPostData,
              GetAvailabilityEndpointAgentToolAvailabilityListPostParameters,
              OperationError<GetAvailabilityEndpointAgentToolAvailabilityListPostError>,
              TContext
            >
          | MutationFiltersByMutationKey<
              GetAvailabilityEndpointAgentToolAvailabilityListPostSchema,
              GetAvailabilityEndpointAgentToolAvailabilityListPostBody,
              GetAvailabilityEndpointAgentToolAvailabilityListPostData,
              GetAvailabilityEndpointAgentToolAvailabilityListPostParameters,
              OperationError<GetAvailabilityEndpointAgentToolAvailabilityListPostError>,
              TContext
            >
      ):
        | Mutation<
            GetAvailabilityEndpointAgentToolAvailabilityListPostData,
            GetAvailabilityEndpointAgentToolAvailabilityListPostError,
            MutationVariables<
              GetAvailabilityEndpointAgentToolAvailabilityListPostBody,
              GetAvailabilityEndpointAgentToolAvailabilityListPostParameters
            >,
            TContext
          >
        | undefined;
      findAll<TContext = unknown>(
        filters?:
          | MutationFiltersByParameters<
              GetAvailabilityEndpointAgentToolAvailabilityListPostBody,
              GetAvailabilityEndpointAgentToolAvailabilityListPostData,
              GetAvailabilityEndpointAgentToolAvailabilityListPostParameters,
              OperationError<GetAvailabilityEndpointAgentToolAvailabilityListPostError>,
              TContext
            >
          | MutationFiltersByMutationKey<
              GetAvailabilityEndpointAgentToolAvailabilityListPostSchema,
              GetAvailabilityEndpointAgentToolAvailabilityListPostBody,
              GetAvailabilityEndpointAgentToolAvailabilityListPostData,
              GetAvailabilityEndpointAgentToolAvailabilityListPostParameters,
              OperationError<GetAvailabilityEndpointAgentToolAvailabilityListPostError>,
              TContext
            >
      ): Array<
        Mutation<
          GetAvailabilityEndpointAgentToolAvailabilityListPostData,
          GetAvailabilityEndpointAgentToolAvailabilityListPostError,
          MutationVariables<
            GetAvailabilityEndpointAgentToolAvailabilityListPostBody,
            GetAvailabilityEndpointAgentToolAvailabilityListPostParameters
          >,
          TContext
        >
      >;
    };
    schema: GetAvailabilityEndpointAgentToolAvailabilityListPostSchema;
    types: {
      parameters: GetAvailabilityEndpointAgentToolAvailabilityListPostParameters;
      data: GetAvailabilityEndpointAgentToolAvailabilityListPostData;
      error: GetAvailabilityEndpointAgentToolAvailabilityListPostError;
      body: GetAvailabilityEndpointAgentToolAvailabilityListPostBody;
    };
  };
  /**
   * @summary List Appointments Endpoint
   * @description List appointments for a customer.
   */
  listAppointmentsEndpointAgentToolAppointmentListPost: {
    /**
     * @summary List Appointments Endpoint
     * @description List appointments for a customer.
     */
    <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(
      options: ServiceOperationMutationFnOptions<
        ListAppointmentsEndpointAgentToolAppointmentListPostBody,
        ListAppointmentsEndpointAgentToolAppointmentListPostParameters,
        TMeta,
        TSignal
      >,
      client?: (
        schema: ListAppointmentsEndpointAgentToolAppointmentListPostSchema,
        options: ServiceOperationMutationFnOptions<
          ListAppointmentsEndpointAgentToolAppointmentListPostBody,
          ListAppointmentsEndpointAgentToolAppointmentListPostParameters,
          TMeta,
          TSignal
        >
      ) => Promise<
        RequestFnResponse<
          ListAppointmentsEndpointAgentToolAppointmentListPostData,
          ListAppointmentsEndpointAgentToolAppointmentListPostError
        >
      >
    ): Promise<
      RequestFnResponse<
        ListAppointmentsEndpointAgentToolAppointmentListPostData,
        ListAppointmentsEndpointAgentToolAppointmentListPostError
      >
    >;
    /**
     * @summary List Appointments Endpoint
     * @description List appointments for a customer.
     */
    getMutationKey(
      parameters: DeepReadonly<ListAppointmentsEndpointAgentToolAppointmentListPostParameters> | void
    ): ServiceOperationMutationKey<
      ListAppointmentsEndpointAgentToolAppointmentListPostSchema,
      ListAppointmentsEndpointAgentToolAppointmentListPostParameters
    >;
    /**
     * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
     * Handles loading state, optimistic updates, and error handling.
     *
     * @summary List Appointments Endpoint
     * @description List appointments for a customer.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
     * @example Mutation with predefined parameters, e.g., for updating
     * ```ts
     * const { mutate, isPending } = qraft.agentToolsService.listAppointmentsEndpointAgentToolAppointmentListPost.useMutation({})
     * mutate(body);
     * ```
     * @example Mutation without predefined parameters, e.g., for creating
     * ```ts
     * const { mutate, isPending } = qraft.agentToolsService.listAppointmentsEndpointAgentToolAppointmentListPost.useMutation()
     * mutate({
     *     body: bodyPayload
     * });
     * ```
     */
    useMutation<TVariables extends ListAppointmentsEndpointAgentToolAppointmentListPostBody, TContext = unknown>(
      parameters: DeepReadonly<ListAppointmentsEndpointAgentToolAppointmentListPostParameters>,
      options?: ServiceOperationUseMutationOptions<
        ListAppointmentsEndpointAgentToolAppointmentListPostSchema,
        ListAppointmentsEndpointAgentToolAppointmentListPostData,
        ListAppointmentsEndpointAgentToolAppointmentListPostParameters,
        TVariables,
        OperationError<ListAppointmentsEndpointAgentToolAppointmentListPostError>,
        TContext
      >
    ): UseMutationResult<
      ListAppointmentsEndpointAgentToolAppointmentListPostData,
      OperationError<ListAppointmentsEndpointAgentToolAppointmentListPostError>,
      TVariables,
      TContext
    >;
    /**
     * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
     * Handles loading state, optimistic updates, and error handling.
     *
     * @summary List Appointments Endpoint
     * @description List appointments for a customer.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
     * @example Mutation with predefined parameters, e.g., for updating
     * ```ts
     * const { mutate, isPending } = qraft.agentToolsService.listAppointmentsEndpointAgentToolAppointmentListPost.useMutation({})
     * mutate(body);
     * ```
     * @example Mutation without predefined parameters, e.g., for creating
     * ```ts
     * const { mutate, isPending } = qraft.agentToolsService.listAppointmentsEndpointAgentToolAppointmentListPost.useMutation()
     * mutate({
     *     body: bodyPayload
     * });
     * ```
     */
    useMutation<
      TVariables extends MutationVariables<
        ListAppointmentsEndpointAgentToolAppointmentListPostBody,
        ListAppointmentsEndpointAgentToolAppointmentListPostParameters
      >,
      TContext = unknown,
    >(
      parameters: void,
      options?: ServiceOperationUseMutationOptions<
        ListAppointmentsEndpointAgentToolAppointmentListPostSchema,
        ListAppointmentsEndpointAgentToolAppointmentListPostData,
        ListAppointmentsEndpointAgentToolAppointmentListPostParameters,
        TVariables,
        OperationError<ListAppointmentsEndpointAgentToolAppointmentListPostError>,
        TContext
      >
    ): UseMutationResult<
      ListAppointmentsEndpointAgentToolAppointmentListPostData,
      OperationError<ListAppointmentsEndpointAgentToolAppointmentListPostError>,
      TVariables,
      TContext
    >;
    /**
     * Returns the count of currently in-progress mutations.
     *
     * @summary List Appointments Endpoint
     * @description List appointments for a customer.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsMutating|`useIsMutating(...)` documentation}
     * @example Check how many mutations are currently in progress for the specified service method.
     * ```ts
     * const listAppointmentsEndpointAgentToolAppointmentListPostTotal = qraft.agentToolsService.listAppointmentsEndpointAgentToolAppointmentListPost.useIsMutating()
     * ```
     * @example Check how many mutations are currently in progress with the specified parameters.
     * ```ts
     * const listAppointmentsEndpointAgentToolAppointmentListPostTotal = qraft.agentToolsService.listAppointmentsEndpointAgentToolAppointmentListPost.useIsMutating({
     *     parameters: {}
     * })
     * ```
     */
    useIsMutating<TContext = unknown>(
      filters?:
        | MutationFiltersByParameters<
            ListAppointmentsEndpointAgentToolAppointmentListPostBody,
            ListAppointmentsEndpointAgentToolAppointmentListPostData,
            ListAppointmentsEndpointAgentToolAppointmentListPostParameters,
            OperationError<ListAppointmentsEndpointAgentToolAppointmentListPostError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            ListAppointmentsEndpointAgentToolAppointmentListPostSchema,
            ListAppointmentsEndpointAgentToolAppointmentListPostBody,
            ListAppointmentsEndpointAgentToolAppointmentListPostData,
            ListAppointmentsEndpointAgentToolAppointmentListPostParameters,
            OperationError<ListAppointmentsEndpointAgentToolAppointmentListPostError>,
            TContext
          >
    ): number;
    /**
     * Provides access to the current state of a mutation, including its status, any resulting data, and associated errors.
     *
     * @summary List Appointments Endpoint
     * @description List appointments for a customer.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutationState|`useMutationState(...)` documentation}
     * @example Get all variables of all running mutations.
     * ```ts
     * const listAppointmentsEndpointAgentToolAppointmentListPostPendingMutationVariables = qraft.agentToolsService.listAppointmentsEndpointAgentToolAppointmentListPost.useMutationState({
     *     filters: {
     *         status: "pending"
     *     },
     *     select: mutation => mutation.state.variables
     * })
     * ```
     * @example Get all data for specific mutations via the `parameters`.
     * ```ts
     * const listAppointmentsEndpointAgentToolAppointmentListPostMutationData = qraft.agentToolsService.listAppointmentsEndpointAgentToolAppointmentListPost.useMutationState({
     *     filters: {
     *         parameters: {}
     *     },
     *     select: mutation => mutation.state.data
     * })
     * ```
     */
    useMutationState<
      TContext = unknown,
      TResult = MutationState<
        ListAppointmentsEndpointAgentToolAppointmentListPostData,
        OperationError<ListAppointmentsEndpointAgentToolAppointmentListPostError>,
        MutationVariables<
          ListAppointmentsEndpointAgentToolAppointmentListPostBody,
          ListAppointmentsEndpointAgentToolAppointmentListPostParameters
        >,
        TContext
      >,
    >(options?: {
      filters?:
        | MutationFiltersByParameters<
            ListAppointmentsEndpointAgentToolAppointmentListPostBody,
            ListAppointmentsEndpointAgentToolAppointmentListPostData,
            ListAppointmentsEndpointAgentToolAppointmentListPostParameters,
            OperationError<ListAppointmentsEndpointAgentToolAppointmentListPostError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            ListAppointmentsEndpointAgentToolAppointmentListPostSchema,
            ListAppointmentsEndpointAgentToolAppointmentListPostBody,
            ListAppointmentsEndpointAgentToolAppointmentListPostData,
            ListAppointmentsEndpointAgentToolAppointmentListPostParameters,
            OperationError<ListAppointmentsEndpointAgentToolAppointmentListPostError>,
            TContext
          >;
      select?: (
        mutation: Mutation<
          ListAppointmentsEndpointAgentToolAppointmentListPostData,
          OperationError<ListAppointmentsEndpointAgentToolAppointmentListPostError>,
          MutationVariables<
            ListAppointmentsEndpointAgentToolAppointmentListPostBody,
            ListAppointmentsEndpointAgentToolAppointmentListPostParameters
          >,
          TContext
        >
      ) => TResult;
    }): Array<TResult>;
    /**
     * @summary List Appointments Endpoint
     * @description List appointments for a customer.
     */
    isMutating<TContext>(
      filters?:
        | MutationFiltersByParameters<
            ListAppointmentsEndpointAgentToolAppointmentListPostBody,
            ListAppointmentsEndpointAgentToolAppointmentListPostData,
            ListAppointmentsEndpointAgentToolAppointmentListPostParameters,
            OperationError<ListAppointmentsEndpointAgentToolAppointmentListPostError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            ListAppointmentsEndpointAgentToolAppointmentListPostSchema,
            ListAppointmentsEndpointAgentToolAppointmentListPostBody,
            ListAppointmentsEndpointAgentToolAppointmentListPostData,
            ListAppointmentsEndpointAgentToolAppointmentListPostParameters,
            OperationError<ListAppointmentsEndpointAgentToolAppointmentListPostError>,
            TContext
          >
    ): number;
    /**
     * Returns a `MutationCache` object that provides access to mutation cache operations
     * for the specific endpoint.
     *
     * @summary List Appointments Endpoint
     * @description List appointments for a customer.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/query-client/getMutationCache|`getMutationCache(...)` documentation}
     *
     * @example Find a mutation with specific parameters
     * ```ts
     * const mutationCache = qraft.agentToolsService.listAppointmentsEndpointAgentToolAppointmentListPost.getMutationCache();
     * const mutation = mutationCache.find({
     *     parameters: {}
     * });
     * ```
     *
     * @example Find all mutations for the endpoint
     * ```ts
     * const mutationCache = qraft.agentToolsService.listAppointmentsEndpointAgentToolAppointmentListPost.getMutationCache();
     * const mutations = mutationCache.findAll();
     * ```
     */
    getMutationCache(): Omit<MutationCache, 'find' | 'findAll'> & {
      find<TContext = unknown>(
        filters:
          | MutationFiltersByParameters<
              ListAppointmentsEndpointAgentToolAppointmentListPostBody,
              ListAppointmentsEndpointAgentToolAppointmentListPostData,
              ListAppointmentsEndpointAgentToolAppointmentListPostParameters,
              OperationError<ListAppointmentsEndpointAgentToolAppointmentListPostError>,
              TContext
            >
          | MutationFiltersByMutationKey<
              ListAppointmentsEndpointAgentToolAppointmentListPostSchema,
              ListAppointmentsEndpointAgentToolAppointmentListPostBody,
              ListAppointmentsEndpointAgentToolAppointmentListPostData,
              ListAppointmentsEndpointAgentToolAppointmentListPostParameters,
              OperationError<ListAppointmentsEndpointAgentToolAppointmentListPostError>,
              TContext
            >
      ):
        | Mutation<
            ListAppointmentsEndpointAgentToolAppointmentListPostData,
            ListAppointmentsEndpointAgentToolAppointmentListPostError,
            MutationVariables<
              ListAppointmentsEndpointAgentToolAppointmentListPostBody,
              ListAppointmentsEndpointAgentToolAppointmentListPostParameters
            >,
            TContext
          >
        | undefined;
      findAll<TContext = unknown>(
        filters?:
          | MutationFiltersByParameters<
              ListAppointmentsEndpointAgentToolAppointmentListPostBody,
              ListAppointmentsEndpointAgentToolAppointmentListPostData,
              ListAppointmentsEndpointAgentToolAppointmentListPostParameters,
              OperationError<ListAppointmentsEndpointAgentToolAppointmentListPostError>,
              TContext
            >
          | MutationFiltersByMutationKey<
              ListAppointmentsEndpointAgentToolAppointmentListPostSchema,
              ListAppointmentsEndpointAgentToolAppointmentListPostBody,
              ListAppointmentsEndpointAgentToolAppointmentListPostData,
              ListAppointmentsEndpointAgentToolAppointmentListPostParameters,
              OperationError<ListAppointmentsEndpointAgentToolAppointmentListPostError>,
              TContext
            >
      ): Array<
        Mutation<
          ListAppointmentsEndpointAgentToolAppointmentListPostData,
          ListAppointmentsEndpointAgentToolAppointmentListPostError,
          MutationVariables<
            ListAppointmentsEndpointAgentToolAppointmentListPostBody,
            ListAppointmentsEndpointAgentToolAppointmentListPostParameters
          >,
          TContext
        >
      >;
    };
    schema: ListAppointmentsEndpointAgentToolAppointmentListPostSchema;
    types: {
      parameters: ListAppointmentsEndpointAgentToolAppointmentListPostParameters;
      data: ListAppointmentsEndpointAgentToolAppointmentListPostData;
      error: ListAppointmentsEndpointAgentToolAppointmentListPostError;
      body: ListAppointmentsEndpointAgentToolAppointmentListPostBody;
    };
  };
  /**
   * @summary List Past Appointments Endpoint
   * @description List past appointments for a customer.
   */
  listPastAppointmentsEndpointAgentToolAppointmentListPastPost: {
    /**
     * @summary List Past Appointments Endpoint
     * @description List past appointments for a customer.
     */
    <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(
      options: ServiceOperationMutationFnOptions<
        ListPastAppointmentsEndpointAgentToolAppointmentListPastPostBody,
        ListPastAppointmentsEndpointAgentToolAppointmentListPastPostParameters,
        TMeta,
        TSignal
      >,
      client?: (
        schema: ListPastAppointmentsEndpointAgentToolAppointmentListPastPostSchema,
        options: ServiceOperationMutationFnOptions<
          ListPastAppointmentsEndpointAgentToolAppointmentListPastPostBody,
          ListPastAppointmentsEndpointAgentToolAppointmentListPastPostParameters,
          TMeta,
          TSignal
        >
      ) => Promise<
        RequestFnResponse<
          ListPastAppointmentsEndpointAgentToolAppointmentListPastPostData,
          ListPastAppointmentsEndpointAgentToolAppointmentListPastPostError
        >
      >
    ): Promise<
      RequestFnResponse<
        ListPastAppointmentsEndpointAgentToolAppointmentListPastPostData,
        ListPastAppointmentsEndpointAgentToolAppointmentListPastPostError
      >
    >;
    /**
     * @summary List Past Appointments Endpoint
     * @description List past appointments for a customer.
     */
    getMutationKey(
      parameters: DeepReadonly<ListPastAppointmentsEndpointAgentToolAppointmentListPastPostParameters> | void
    ): ServiceOperationMutationKey<
      ListPastAppointmentsEndpointAgentToolAppointmentListPastPostSchema,
      ListPastAppointmentsEndpointAgentToolAppointmentListPastPostParameters
    >;
    /**
     * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
     * Handles loading state, optimistic updates, and error handling.
     *
     * @summary List Past Appointments Endpoint
     * @description List past appointments for a customer.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
     * @example Mutation with predefined parameters, e.g., for updating
     * ```ts
     * const { mutate, isPending } = qraft.agentToolsService.listPastAppointmentsEndpointAgentToolAppointmentListPastPost.useMutation({})
     * mutate(body);
     * ```
     * @example Mutation without predefined parameters, e.g., for creating
     * ```ts
     * const { mutate, isPending } = qraft.agentToolsService.listPastAppointmentsEndpointAgentToolAppointmentListPastPost.useMutation()
     * mutate({
     *     body: bodyPayload
     * });
     * ```
     */
    useMutation<
      TVariables extends ListPastAppointmentsEndpointAgentToolAppointmentListPastPostBody,
      TContext = unknown,
    >(
      parameters: DeepReadonly<ListPastAppointmentsEndpointAgentToolAppointmentListPastPostParameters>,
      options?: ServiceOperationUseMutationOptions<
        ListPastAppointmentsEndpointAgentToolAppointmentListPastPostSchema,
        ListPastAppointmentsEndpointAgentToolAppointmentListPastPostData,
        ListPastAppointmentsEndpointAgentToolAppointmentListPastPostParameters,
        TVariables,
        OperationError<ListPastAppointmentsEndpointAgentToolAppointmentListPastPostError>,
        TContext
      >
    ): UseMutationResult<
      ListPastAppointmentsEndpointAgentToolAppointmentListPastPostData,
      OperationError<ListPastAppointmentsEndpointAgentToolAppointmentListPastPostError>,
      TVariables,
      TContext
    >;
    /**
     * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
     * Handles loading state, optimistic updates, and error handling.
     *
     * @summary List Past Appointments Endpoint
     * @description List past appointments for a customer.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
     * @example Mutation with predefined parameters, e.g., for updating
     * ```ts
     * const { mutate, isPending } = qraft.agentToolsService.listPastAppointmentsEndpointAgentToolAppointmentListPastPost.useMutation({})
     * mutate(body);
     * ```
     * @example Mutation without predefined parameters, e.g., for creating
     * ```ts
     * const { mutate, isPending } = qraft.agentToolsService.listPastAppointmentsEndpointAgentToolAppointmentListPastPost.useMutation()
     * mutate({
     *     body: bodyPayload
     * });
     * ```
     */
    useMutation<
      TVariables extends MutationVariables<
        ListPastAppointmentsEndpointAgentToolAppointmentListPastPostBody,
        ListPastAppointmentsEndpointAgentToolAppointmentListPastPostParameters
      >,
      TContext = unknown,
    >(
      parameters: void,
      options?: ServiceOperationUseMutationOptions<
        ListPastAppointmentsEndpointAgentToolAppointmentListPastPostSchema,
        ListPastAppointmentsEndpointAgentToolAppointmentListPastPostData,
        ListPastAppointmentsEndpointAgentToolAppointmentListPastPostParameters,
        TVariables,
        OperationError<ListPastAppointmentsEndpointAgentToolAppointmentListPastPostError>,
        TContext
      >
    ): UseMutationResult<
      ListPastAppointmentsEndpointAgentToolAppointmentListPastPostData,
      OperationError<ListPastAppointmentsEndpointAgentToolAppointmentListPastPostError>,
      TVariables,
      TContext
    >;
    /**
     * Returns the count of currently in-progress mutations.
     *
     * @summary List Past Appointments Endpoint
     * @description List past appointments for a customer.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsMutating|`useIsMutating(...)` documentation}
     * @example Check how many mutations are currently in progress for the specified service method.
     * ```ts
     * const listPastAppointmentsEndpointAgentToolAppointmentListPastPostTotal = qraft.agentToolsService.listPastAppointmentsEndpointAgentToolAppointmentListPastPost.useIsMutating()
     * ```
     * @example Check how many mutations are currently in progress with the specified parameters.
     * ```ts
     * const listPastAppointmentsEndpointAgentToolAppointmentListPastPostTotal = qraft.agentToolsService.listPastAppointmentsEndpointAgentToolAppointmentListPastPost.useIsMutating({
     *     parameters: {}
     * })
     * ```
     */
    useIsMutating<TContext = unknown>(
      filters?:
        | MutationFiltersByParameters<
            ListPastAppointmentsEndpointAgentToolAppointmentListPastPostBody,
            ListPastAppointmentsEndpointAgentToolAppointmentListPastPostData,
            ListPastAppointmentsEndpointAgentToolAppointmentListPastPostParameters,
            OperationError<ListPastAppointmentsEndpointAgentToolAppointmentListPastPostError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            ListPastAppointmentsEndpointAgentToolAppointmentListPastPostSchema,
            ListPastAppointmentsEndpointAgentToolAppointmentListPastPostBody,
            ListPastAppointmentsEndpointAgentToolAppointmentListPastPostData,
            ListPastAppointmentsEndpointAgentToolAppointmentListPastPostParameters,
            OperationError<ListPastAppointmentsEndpointAgentToolAppointmentListPastPostError>,
            TContext
          >
    ): number;
    /**
     * Provides access to the current state of a mutation, including its status, any resulting data, and associated errors.
     *
     * @summary List Past Appointments Endpoint
     * @description List past appointments for a customer.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutationState|`useMutationState(...)` documentation}
     * @example Get all variables of all running mutations.
     * ```ts
     * const listPastAppointmentsEndpointAgentToolAppointmentListPastPostPendingMutationVariables = qraft.agentToolsService.listPastAppointmentsEndpointAgentToolAppointmentListPastPost.useMutationState({
     *     filters: {
     *         status: "pending"
     *     },
     *     select: mutation => mutation.state.variables
     * })
     * ```
     * @example Get all data for specific mutations via the `parameters`.
     * ```ts
     * const listPastAppointmentsEndpointAgentToolAppointmentListPastPostMutationData = qraft.agentToolsService.listPastAppointmentsEndpointAgentToolAppointmentListPastPost.useMutationState({
     *     filters: {
     *         parameters: {}
     *     },
     *     select: mutation => mutation.state.data
     * })
     * ```
     */
    useMutationState<
      TContext = unknown,
      TResult = MutationState<
        ListPastAppointmentsEndpointAgentToolAppointmentListPastPostData,
        OperationError<ListPastAppointmentsEndpointAgentToolAppointmentListPastPostError>,
        MutationVariables<
          ListPastAppointmentsEndpointAgentToolAppointmentListPastPostBody,
          ListPastAppointmentsEndpointAgentToolAppointmentListPastPostParameters
        >,
        TContext
      >,
    >(options?: {
      filters?:
        | MutationFiltersByParameters<
            ListPastAppointmentsEndpointAgentToolAppointmentListPastPostBody,
            ListPastAppointmentsEndpointAgentToolAppointmentListPastPostData,
            ListPastAppointmentsEndpointAgentToolAppointmentListPastPostParameters,
            OperationError<ListPastAppointmentsEndpointAgentToolAppointmentListPastPostError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            ListPastAppointmentsEndpointAgentToolAppointmentListPastPostSchema,
            ListPastAppointmentsEndpointAgentToolAppointmentListPastPostBody,
            ListPastAppointmentsEndpointAgentToolAppointmentListPastPostData,
            ListPastAppointmentsEndpointAgentToolAppointmentListPastPostParameters,
            OperationError<ListPastAppointmentsEndpointAgentToolAppointmentListPastPostError>,
            TContext
          >;
      select?: (
        mutation: Mutation<
          ListPastAppointmentsEndpointAgentToolAppointmentListPastPostData,
          OperationError<ListPastAppointmentsEndpointAgentToolAppointmentListPastPostError>,
          MutationVariables<
            ListPastAppointmentsEndpointAgentToolAppointmentListPastPostBody,
            ListPastAppointmentsEndpointAgentToolAppointmentListPastPostParameters
          >,
          TContext
        >
      ) => TResult;
    }): Array<TResult>;
    /**
     * @summary List Past Appointments Endpoint
     * @description List past appointments for a customer.
     */
    isMutating<TContext>(
      filters?:
        | MutationFiltersByParameters<
            ListPastAppointmentsEndpointAgentToolAppointmentListPastPostBody,
            ListPastAppointmentsEndpointAgentToolAppointmentListPastPostData,
            ListPastAppointmentsEndpointAgentToolAppointmentListPastPostParameters,
            OperationError<ListPastAppointmentsEndpointAgentToolAppointmentListPastPostError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            ListPastAppointmentsEndpointAgentToolAppointmentListPastPostSchema,
            ListPastAppointmentsEndpointAgentToolAppointmentListPastPostBody,
            ListPastAppointmentsEndpointAgentToolAppointmentListPastPostData,
            ListPastAppointmentsEndpointAgentToolAppointmentListPastPostParameters,
            OperationError<ListPastAppointmentsEndpointAgentToolAppointmentListPastPostError>,
            TContext
          >
    ): number;
    /**
     * Returns a `MutationCache` object that provides access to mutation cache operations
     * for the specific endpoint.
     *
     * @summary List Past Appointments Endpoint
     * @description List past appointments for a customer.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/query-client/getMutationCache|`getMutationCache(...)` documentation}
     *
     * @example Find a mutation with specific parameters
     * ```ts
     * const mutationCache = qraft.agentToolsService.listPastAppointmentsEndpointAgentToolAppointmentListPastPost.getMutationCache();
     * const mutation = mutationCache.find({
     *     parameters: {}
     * });
     * ```
     *
     * @example Find all mutations for the endpoint
     * ```ts
     * const mutationCache = qraft.agentToolsService.listPastAppointmentsEndpointAgentToolAppointmentListPastPost.getMutationCache();
     * const mutations = mutationCache.findAll();
     * ```
     */
    getMutationCache(): Omit<MutationCache, 'find' | 'findAll'> & {
      find<TContext = unknown>(
        filters:
          | MutationFiltersByParameters<
              ListPastAppointmentsEndpointAgentToolAppointmentListPastPostBody,
              ListPastAppointmentsEndpointAgentToolAppointmentListPastPostData,
              ListPastAppointmentsEndpointAgentToolAppointmentListPastPostParameters,
              OperationError<ListPastAppointmentsEndpointAgentToolAppointmentListPastPostError>,
              TContext
            >
          | MutationFiltersByMutationKey<
              ListPastAppointmentsEndpointAgentToolAppointmentListPastPostSchema,
              ListPastAppointmentsEndpointAgentToolAppointmentListPastPostBody,
              ListPastAppointmentsEndpointAgentToolAppointmentListPastPostData,
              ListPastAppointmentsEndpointAgentToolAppointmentListPastPostParameters,
              OperationError<ListPastAppointmentsEndpointAgentToolAppointmentListPastPostError>,
              TContext
            >
      ):
        | Mutation<
            ListPastAppointmentsEndpointAgentToolAppointmentListPastPostData,
            ListPastAppointmentsEndpointAgentToolAppointmentListPastPostError,
            MutationVariables<
              ListPastAppointmentsEndpointAgentToolAppointmentListPastPostBody,
              ListPastAppointmentsEndpointAgentToolAppointmentListPastPostParameters
            >,
            TContext
          >
        | undefined;
      findAll<TContext = unknown>(
        filters?:
          | MutationFiltersByParameters<
              ListPastAppointmentsEndpointAgentToolAppointmentListPastPostBody,
              ListPastAppointmentsEndpointAgentToolAppointmentListPastPostData,
              ListPastAppointmentsEndpointAgentToolAppointmentListPastPostParameters,
              OperationError<ListPastAppointmentsEndpointAgentToolAppointmentListPastPostError>,
              TContext
            >
          | MutationFiltersByMutationKey<
              ListPastAppointmentsEndpointAgentToolAppointmentListPastPostSchema,
              ListPastAppointmentsEndpointAgentToolAppointmentListPastPostBody,
              ListPastAppointmentsEndpointAgentToolAppointmentListPastPostData,
              ListPastAppointmentsEndpointAgentToolAppointmentListPastPostParameters,
              OperationError<ListPastAppointmentsEndpointAgentToolAppointmentListPastPostError>,
              TContext
            >
      ): Array<
        Mutation<
          ListPastAppointmentsEndpointAgentToolAppointmentListPastPostData,
          ListPastAppointmentsEndpointAgentToolAppointmentListPastPostError,
          MutationVariables<
            ListPastAppointmentsEndpointAgentToolAppointmentListPastPostBody,
            ListPastAppointmentsEndpointAgentToolAppointmentListPastPostParameters
          >,
          TContext
        >
      >;
    };
    schema: ListPastAppointmentsEndpointAgentToolAppointmentListPastPostSchema;
    types: {
      parameters: ListPastAppointmentsEndpointAgentToolAppointmentListPastPostParameters;
      data: ListPastAppointmentsEndpointAgentToolAppointmentListPastPostData;
      error: ListPastAppointmentsEndpointAgentToolAppointmentListPastPostError;
      body: ListPastAppointmentsEndpointAgentToolAppointmentListPastPostBody;
    };
  };
  /**
   * @summary List Upcoming Appointments Endpoint
   * @description List upcoming appointments for a customer.
   */
  listUpcomingAppointmentsEndpointAgentToolAppointmentListUpcomingPost: {
    /**
     * @summary List Upcoming Appointments Endpoint
     * @description List upcoming appointments for a customer.
     */
    <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(
      options: ServiceOperationMutationFnOptions<
        ListUpcomingAppointmentsEndpointAgentToolAppointmentListUpcomingPostBody,
        ListUpcomingAppointmentsEndpointAgentToolAppointmentListUpcomingPostParameters,
        TMeta,
        TSignal
      >,
      client?: (
        schema: ListUpcomingAppointmentsEndpointAgentToolAppointmentListUpcomingPostSchema,
        options: ServiceOperationMutationFnOptions<
          ListUpcomingAppointmentsEndpointAgentToolAppointmentListUpcomingPostBody,
          ListUpcomingAppointmentsEndpointAgentToolAppointmentListUpcomingPostParameters,
          TMeta,
          TSignal
        >
      ) => Promise<
        RequestFnResponse<
          ListUpcomingAppointmentsEndpointAgentToolAppointmentListUpcomingPostData,
          ListUpcomingAppointmentsEndpointAgentToolAppointmentListUpcomingPostError
        >
      >
    ): Promise<
      RequestFnResponse<
        ListUpcomingAppointmentsEndpointAgentToolAppointmentListUpcomingPostData,
        ListUpcomingAppointmentsEndpointAgentToolAppointmentListUpcomingPostError
      >
    >;
    /**
     * @summary List Upcoming Appointments Endpoint
     * @description List upcoming appointments for a customer.
     */
    getMutationKey(
      parameters: DeepReadonly<ListUpcomingAppointmentsEndpointAgentToolAppointmentListUpcomingPostParameters> | void
    ): ServiceOperationMutationKey<
      ListUpcomingAppointmentsEndpointAgentToolAppointmentListUpcomingPostSchema,
      ListUpcomingAppointmentsEndpointAgentToolAppointmentListUpcomingPostParameters
    >;
    /**
     * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
     * Handles loading state, optimistic updates, and error handling.
     *
     * @summary List Upcoming Appointments Endpoint
     * @description List upcoming appointments for a customer.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
     * @example Mutation with predefined parameters, e.g., for updating
     * ```ts
     * const { mutate, isPending } = qraft.agentToolsService.listUpcomingAppointmentsEndpointAgentToolAppointmentListUpcomingPost.useMutation({})
     * mutate(body);
     * ```
     * @example Mutation without predefined parameters, e.g., for creating
     * ```ts
     * const { mutate, isPending } = qraft.agentToolsService.listUpcomingAppointmentsEndpointAgentToolAppointmentListUpcomingPost.useMutation()
     * mutate({
     *     body: bodyPayload
     * });
     * ```
     */
    useMutation<
      TVariables extends ListUpcomingAppointmentsEndpointAgentToolAppointmentListUpcomingPostBody,
      TContext = unknown,
    >(
      parameters: DeepReadonly<ListUpcomingAppointmentsEndpointAgentToolAppointmentListUpcomingPostParameters>,
      options?: ServiceOperationUseMutationOptions<
        ListUpcomingAppointmentsEndpointAgentToolAppointmentListUpcomingPostSchema,
        ListUpcomingAppointmentsEndpointAgentToolAppointmentListUpcomingPostData,
        ListUpcomingAppointmentsEndpointAgentToolAppointmentListUpcomingPostParameters,
        TVariables,
        OperationError<ListUpcomingAppointmentsEndpointAgentToolAppointmentListUpcomingPostError>,
        TContext
      >
    ): UseMutationResult<
      ListUpcomingAppointmentsEndpointAgentToolAppointmentListUpcomingPostData,
      OperationError<ListUpcomingAppointmentsEndpointAgentToolAppointmentListUpcomingPostError>,
      TVariables,
      TContext
    >;
    /**
     * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
     * Handles loading state, optimistic updates, and error handling.
     *
     * @summary List Upcoming Appointments Endpoint
     * @description List upcoming appointments for a customer.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
     * @example Mutation with predefined parameters, e.g., for updating
     * ```ts
     * const { mutate, isPending } = qraft.agentToolsService.listUpcomingAppointmentsEndpointAgentToolAppointmentListUpcomingPost.useMutation({})
     * mutate(body);
     * ```
     * @example Mutation without predefined parameters, e.g., for creating
     * ```ts
     * const { mutate, isPending } = qraft.agentToolsService.listUpcomingAppointmentsEndpointAgentToolAppointmentListUpcomingPost.useMutation()
     * mutate({
     *     body: bodyPayload
     * });
     * ```
     */
    useMutation<
      TVariables extends MutationVariables<
        ListUpcomingAppointmentsEndpointAgentToolAppointmentListUpcomingPostBody,
        ListUpcomingAppointmentsEndpointAgentToolAppointmentListUpcomingPostParameters
      >,
      TContext = unknown,
    >(
      parameters: void,
      options?: ServiceOperationUseMutationOptions<
        ListUpcomingAppointmentsEndpointAgentToolAppointmentListUpcomingPostSchema,
        ListUpcomingAppointmentsEndpointAgentToolAppointmentListUpcomingPostData,
        ListUpcomingAppointmentsEndpointAgentToolAppointmentListUpcomingPostParameters,
        TVariables,
        OperationError<ListUpcomingAppointmentsEndpointAgentToolAppointmentListUpcomingPostError>,
        TContext
      >
    ): UseMutationResult<
      ListUpcomingAppointmentsEndpointAgentToolAppointmentListUpcomingPostData,
      OperationError<ListUpcomingAppointmentsEndpointAgentToolAppointmentListUpcomingPostError>,
      TVariables,
      TContext
    >;
    /**
     * Returns the count of currently in-progress mutations.
     *
     * @summary List Upcoming Appointments Endpoint
     * @description List upcoming appointments for a customer.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsMutating|`useIsMutating(...)` documentation}
     * @example Check how many mutations are currently in progress for the specified service method.
     * ```ts
     * const listUpcomingAppointmentsEndpointAgentToolAppointmentListUpcomingPostTotal = qraft.agentToolsService.listUpcomingAppointmentsEndpointAgentToolAppointmentListUpcomingPost.useIsMutating()
     * ```
     * @example Check how many mutations are currently in progress with the specified parameters.
     * ```ts
     * const listUpcomingAppointmentsEndpointAgentToolAppointmentListUpcomingPostTotal = qraft.agentToolsService.listUpcomingAppointmentsEndpointAgentToolAppointmentListUpcomingPost.useIsMutating({
     *     parameters: {}
     * })
     * ```
     */
    useIsMutating<TContext = unknown>(
      filters?:
        | MutationFiltersByParameters<
            ListUpcomingAppointmentsEndpointAgentToolAppointmentListUpcomingPostBody,
            ListUpcomingAppointmentsEndpointAgentToolAppointmentListUpcomingPostData,
            ListUpcomingAppointmentsEndpointAgentToolAppointmentListUpcomingPostParameters,
            OperationError<ListUpcomingAppointmentsEndpointAgentToolAppointmentListUpcomingPostError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            ListUpcomingAppointmentsEndpointAgentToolAppointmentListUpcomingPostSchema,
            ListUpcomingAppointmentsEndpointAgentToolAppointmentListUpcomingPostBody,
            ListUpcomingAppointmentsEndpointAgentToolAppointmentListUpcomingPostData,
            ListUpcomingAppointmentsEndpointAgentToolAppointmentListUpcomingPostParameters,
            OperationError<ListUpcomingAppointmentsEndpointAgentToolAppointmentListUpcomingPostError>,
            TContext
          >
    ): number;
    /**
     * Provides access to the current state of a mutation, including its status, any resulting data, and associated errors.
     *
     * @summary List Upcoming Appointments Endpoint
     * @description List upcoming appointments for a customer.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutationState|`useMutationState(...)` documentation}
     * @example Get all variables of all running mutations.
     * ```ts
     * const listUpcomingAppointmentsEndpointAgentToolAppointmentListUpcomingPostPendingMutationVariables = qraft.agentToolsService.listUpcomingAppointmentsEndpointAgentToolAppointmentListUpcomingPost.useMutationState({
     *     filters: {
     *         status: "pending"
     *     },
     *     select: mutation => mutation.state.variables
     * })
     * ```
     * @example Get all data for specific mutations via the `parameters`.
     * ```ts
     * const listUpcomingAppointmentsEndpointAgentToolAppointmentListUpcomingPostMutationData = qraft.agentToolsService.listUpcomingAppointmentsEndpointAgentToolAppointmentListUpcomingPost.useMutationState({
     *     filters: {
     *         parameters: {}
     *     },
     *     select: mutation => mutation.state.data
     * })
     * ```
     */
    useMutationState<
      TContext = unknown,
      TResult = MutationState<
        ListUpcomingAppointmentsEndpointAgentToolAppointmentListUpcomingPostData,
        OperationError<ListUpcomingAppointmentsEndpointAgentToolAppointmentListUpcomingPostError>,
        MutationVariables<
          ListUpcomingAppointmentsEndpointAgentToolAppointmentListUpcomingPostBody,
          ListUpcomingAppointmentsEndpointAgentToolAppointmentListUpcomingPostParameters
        >,
        TContext
      >,
    >(options?: {
      filters?:
        | MutationFiltersByParameters<
            ListUpcomingAppointmentsEndpointAgentToolAppointmentListUpcomingPostBody,
            ListUpcomingAppointmentsEndpointAgentToolAppointmentListUpcomingPostData,
            ListUpcomingAppointmentsEndpointAgentToolAppointmentListUpcomingPostParameters,
            OperationError<ListUpcomingAppointmentsEndpointAgentToolAppointmentListUpcomingPostError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            ListUpcomingAppointmentsEndpointAgentToolAppointmentListUpcomingPostSchema,
            ListUpcomingAppointmentsEndpointAgentToolAppointmentListUpcomingPostBody,
            ListUpcomingAppointmentsEndpointAgentToolAppointmentListUpcomingPostData,
            ListUpcomingAppointmentsEndpointAgentToolAppointmentListUpcomingPostParameters,
            OperationError<ListUpcomingAppointmentsEndpointAgentToolAppointmentListUpcomingPostError>,
            TContext
          >;
      select?: (
        mutation: Mutation<
          ListUpcomingAppointmentsEndpointAgentToolAppointmentListUpcomingPostData,
          OperationError<ListUpcomingAppointmentsEndpointAgentToolAppointmentListUpcomingPostError>,
          MutationVariables<
            ListUpcomingAppointmentsEndpointAgentToolAppointmentListUpcomingPostBody,
            ListUpcomingAppointmentsEndpointAgentToolAppointmentListUpcomingPostParameters
          >,
          TContext
        >
      ) => TResult;
    }): Array<TResult>;
    /**
     * @summary List Upcoming Appointments Endpoint
     * @description List upcoming appointments for a customer.
     */
    isMutating<TContext>(
      filters?:
        | MutationFiltersByParameters<
            ListUpcomingAppointmentsEndpointAgentToolAppointmentListUpcomingPostBody,
            ListUpcomingAppointmentsEndpointAgentToolAppointmentListUpcomingPostData,
            ListUpcomingAppointmentsEndpointAgentToolAppointmentListUpcomingPostParameters,
            OperationError<ListUpcomingAppointmentsEndpointAgentToolAppointmentListUpcomingPostError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            ListUpcomingAppointmentsEndpointAgentToolAppointmentListUpcomingPostSchema,
            ListUpcomingAppointmentsEndpointAgentToolAppointmentListUpcomingPostBody,
            ListUpcomingAppointmentsEndpointAgentToolAppointmentListUpcomingPostData,
            ListUpcomingAppointmentsEndpointAgentToolAppointmentListUpcomingPostParameters,
            OperationError<ListUpcomingAppointmentsEndpointAgentToolAppointmentListUpcomingPostError>,
            TContext
          >
    ): number;
    /**
     * Returns a `MutationCache` object that provides access to mutation cache operations
     * for the specific endpoint.
     *
     * @summary List Upcoming Appointments Endpoint
     * @description List upcoming appointments for a customer.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/query-client/getMutationCache|`getMutationCache(...)` documentation}
     *
     * @example Find a mutation with specific parameters
     * ```ts
     * const mutationCache = qraft.agentToolsService.listUpcomingAppointmentsEndpointAgentToolAppointmentListUpcomingPost.getMutationCache();
     * const mutation = mutationCache.find({
     *     parameters: {}
     * });
     * ```
     *
     * @example Find all mutations for the endpoint
     * ```ts
     * const mutationCache = qraft.agentToolsService.listUpcomingAppointmentsEndpointAgentToolAppointmentListUpcomingPost.getMutationCache();
     * const mutations = mutationCache.findAll();
     * ```
     */
    getMutationCache(): Omit<MutationCache, 'find' | 'findAll'> & {
      find<TContext = unknown>(
        filters:
          | MutationFiltersByParameters<
              ListUpcomingAppointmentsEndpointAgentToolAppointmentListUpcomingPostBody,
              ListUpcomingAppointmentsEndpointAgentToolAppointmentListUpcomingPostData,
              ListUpcomingAppointmentsEndpointAgentToolAppointmentListUpcomingPostParameters,
              OperationError<ListUpcomingAppointmentsEndpointAgentToolAppointmentListUpcomingPostError>,
              TContext
            >
          | MutationFiltersByMutationKey<
              ListUpcomingAppointmentsEndpointAgentToolAppointmentListUpcomingPostSchema,
              ListUpcomingAppointmentsEndpointAgentToolAppointmentListUpcomingPostBody,
              ListUpcomingAppointmentsEndpointAgentToolAppointmentListUpcomingPostData,
              ListUpcomingAppointmentsEndpointAgentToolAppointmentListUpcomingPostParameters,
              OperationError<ListUpcomingAppointmentsEndpointAgentToolAppointmentListUpcomingPostError>,
              TContext
            >
      ):
        | Mutation<
            ListUpcomingAppointmentsEndpointAgentToolAppointmentListUpcomingPostData,
            ListUpcomingAppointmentsEndpointAgentToolAppointmentListUpcomingPostError,
            MutationVariables<
              ListUpcomingAppointmentsEndpointAgentToolAppointmentListUpcomingPostBody,
              ListUpcomingAppointmentsEndpointAgentToolAppointmentListUpcomingPostParameters
            >,
            TContext
          >
        | undefined;
      findAll<TContext = unknown>(
        filters?:
          | MutationFiltersByParameters<
              ListUpcomingAppointmentsEndpointAgentToolAppointmentListUpcomingPostBody,
              ListUpcomingAppointmentsEndpointAgentToolAppointmentListUpcomingPostData,
              ListUpcomingAppointmentsEndpointAgentToolAppointmentListUpcomingPostParameters,
              OperationError<ListUpcomingAppointmentsEndpointAgentToolAppointmentListUpcomingPostError>,
              TContext
            >
          | MutationFiltersByMutationKey<
              ListUpcomingAppointmentsEndpointAgentToolAppointmentListUpcomingPostSchema,
              ListUpcomingAppointmentsEndpointAgentToolAppointmentListUpcomingPostBody,
              ListUpcomingAppointmentsEndpointAgentToolAppointmentListUpcomingPostData,
              ListUpcomingAppointmentsEndpointAgentToolAppointmentListUpcomingPostParameters,
              OperationError<ListUpcomingAppointmentsEndpointAgentToolAppointmentListUpcomingPostError>,
              TContext
            >
      ): Array<
        Mutation<
          ListUpcomingAppointmentsEndpointAgentToolAppointmentListUpcomingPostData,
          ListUpcomingAppointmentsEndpointAgentToolAppointmentListUpcomingPostError,
          MutationVariables<
            ListUpcomingAppointmentsEndpointAgentToolAppointmentListUpcomingPostBody,
            ListUpcomingAppointmentsEndpointAgentToolAppointmentListUpcomingPostParameters
          >,
          TContext
        >
      >;
    };
    schema: ListUpcomingAppointmentsEndpointAgentToolAppointmentListUpcomingPostSchema;
    types: {
      parameters: ListUpcomingAppointmentsEndpointAgentToolAppointmentListUpcomingPostParameters;
      data: ListUpcomingAppointmentsEndpointAgentToolAppointmentListUpcomingPostData;
      error: ListUpcomingAppointmentsEndpointAgentToolAppointmentListUpcomingPostError;
      body: ListUpcomingAppointmentsEndpointAgentToolAppointmentListUpcomingPostBody;
    };
  };
  /**
   * @summary Book Appointment Endpoint
   * @description Book a new appointment for a customer.
   */
  bookAppointmentEndpointAgentToolAppointmentBookPost: {
    /**
     * @summary Book Appointment Endpoint
     * @description Book a new appointment for a customer.
     */
    <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(
      options: ServiceOperationMutationFnOptions<
        BookAppointmentEndpointAgentToolAppointmentBookPostBody,
        BookAppointmentEndpointAgentToolAppointmentBookPostParameters,
        TMeta,
        TSignal
      >,
      client?: (
        schema: BookAppointmentEndpointAgentToolAppointmentBookPostSchema,
        options: ServiceOperationMutationFnOptions<
          BookAppointmentEndpointAgentToolAppointmentBookPostBody,
          BookAppointmentEndpointAgentToolAppointmentBookPostParameters,
          TMeta,
          TSignal
        >
      ) => Promise<
        RequestFnResponse<
          BookAppointmentEndpointAgentToolAppointmentBookPostData,
          BookAppointmentEndpointAgentToolAppointmentBookPostError
        >
      >
    ): Promise<
      RequestFnResponse<
        BookAppointmentEndpointAgentToolAppointmentBookPostData,
        BookAppointmentEndpointAgentToolAppointmentBookPostError
      >
    >;
    /**
     * @summary Book Appointment Endpoint
     * @description Book a new appointment for a customer.
     */
    getMutationKey(
      parameters: DeepReadonly<BookAppointmentEndpointAgentToolAppointmentBookPostParameters> | void
    ): ServiceOperationMutationKey<
      BookAppointmentEndpointAgentToolAppointmentBookPostSchema,
      BookAppointmentEndpointAgentToolAppointmentBookPostParameters
    >;
    /**
     * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
     * Handles loading state, optimistic updates, and error handling.
     *
     * @summary Book Appointment Endpoint
     * @description Book a new appointment for a customer.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
     * @example Mutation with predefined parameters, e.g., for updating
     * ```ts
     * const { mutate, isPending } = qraft.agentToolsService.bookAppointmentEndpointAgentToolAppointmentBookPost.useMutation({})
     * mutate(body);
     * ```
     * @example Mutation without predefined parameters, e.g., for creating
     * ```ts
     * const { mutate, isPending } = qraft.agentToolsService.bookAppointmentEndpointAgentToolAppointmentBookPost.useMutation()
     * mutate({
     *     body: bodyPayload
     * });
     * ```
     */
    useMutation<TVariables extends BookAppointmentEndpointAgentToolAppointmentBookPostBody, TContext = unknown>(
      parameters: DeepReadonly<BookAppointmentEndpointAgentToolAppointmentBookPostParameters>,
      options?: ServiceOperationUseMutationOptions<
        BookAppointmentEndpointAgentToolAppointmentBookPostSchema,
        BookAppointmentEndpointAgentToolAppointmentBookPostData,
        BookAppointmentEndpointAgentToolAppointmentBookPostParameters,
        TVariables,
        OperationError<BookAppointmentEndpointAgentToolAppointmentBookPostError>,
        TContext
      >
    ): UseMutationResult<
      BookAppointmentEndpointAgentToolAppointmentBookPostData,
      OperationError<BookAppointmentEndpointAgentToolAppointmentBookPostError>,
      TVariables,
      TContext
    >;
    /**
     * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
     * Handles loading state, optimistic updates, and error handling.
     *
     * @summary Book Appointment Endpoint
     * @description Book a new appointment for a customer.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
     * @example Mutation with predefined parameters, e.g., for updating
     * ```ts
     * const { mutate, isPending } = qraft.agentToolsService.bookAppointmentEndpointAgentToolAppointmentBookPost.useMutation({})
     * mutate(body);
     * ```
     * @example Mutation without predefined parameters, e.g., for creating
     * ```ts
     * const { mutate, isPending } = qraft.agentToolsService.bookAppointmentEndpointAgentToolAppointmentBookPost.useMutation()
     * mutate({
     *     body: bodyPayload
     * });
     * ```
     */
    useMutation<
      TVariables extends MutationVariables<
        BookAppointmentEndpointAgentToolAppointmentBookPostBody,
        BookAppointmentEndpointAgentToolAppointmentBookPostParameters
      >,
      TContext = unknown,
    >(
      parameters: void,
      options?: ServiceOperationUseMutationOptions<
        BookAppointmentEndpointAgentToolAppointmentBookPostSchema,
        BookAppointmentEndpointAgentToolAppointmentBookPostData,
        BookAppointmentEndpointAgentToolAppointmentBookPostParameters,
        TVariables,
        OperationError<BookAppointmentEndpointAgentToolAppointmentBookPostError>,
        TContext
      >
    ): UseMutationResult<
      BookAppointmentEndpointAgentToolAppointmentBookPostData,
      OperationError<BookAppointmentEndpointAgentToolAppointmentBookPostError>,
      TVariables,
      TContext
    >;
    /**
     * Returns the count of currently in-progress mutations.
     *
     * @summary Book Appointment Endpoint
     * @description Book a new appointment for a customer.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsMutating|`useIsMutating(...)` documentation}
     * @example Check how many mutations are currently in progress for the specified service method.
     * ```ts
     * const bookAppointmentEndpointAgentToolAppointmentBookPostTotal = qraft.agentToolsService.bookAppointmentEndpointAgentToolAppointmentBookPost.useIsMutating()
     * ```
     * @example Check how many mutations are currently in progress with the specified parameters.
     * ```ts
     * const bookAppointmentEndpointAgentToolAppointmentBookPostTotal = qraft.agentToolsService.bookAppointmentEndpointAgentToolAppointmentBookPost.useIsMutating({
     *     parameters: {}
     * })
     * ```
     */
    useIsMutating<TContext = unknown>(
      filters?:
        | MutationFiltersByParameters<
            BookAppointmentEndpointAgentToolAppointmentBookPostBody,
            BookAppointmentEndpointAgentToolAppointmentBookPostData,
            BookAppointmentEndpointAgentToolAppointmentBookPostParameters,
            OperationError<BookAppointmentEndpointAgentToolAppointmentBookPostError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            BookAppointmentEndpointAgentToolAppointmentBookPostSchema,
            BookAppointmentEndpointAgentToolAppointmentBookPostBody,
            BookAppointmentEndpointAgentToolAppointmentBookPostData,
            BookAppointmentEndpointAgentToolAppointmentBookPostParameters,
            OperationError<BookAppointmentEndpointAgentToolAppointmentBookPostError>,
            TContext
          >
    ): number;
    /**
     * Provides access to the current state of a mutation, including its status, any resulting data, and associated errors.
     *
     * @summary Book Appointment Endpoint
     * @description Book a new appointment for a customer.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutationState|`useMutationState(...)` documentation}
     * @example Get all variables of all running mutations.
     * ```ts
     * const bookAppointmentEndpointAgentToolAppointmentBookPostPendingMutationVariables = qraft.agentToolsService.bookAppointmentEndpointAgentToolAppointmentBookPost.useMutationState({
     *     filters: {
     *         status: "pending"
     *     },
     *     select: mutation => mutation.state.variables
     * })
     * ```
     * @example Get all data for specific mutations via the `parameters`.
     * ```ts
     * const bookAppointmentEndpointAgentToolAppointmentBookPostMutationData = qraft.agentToolsService.bookAppointmentEndpointAgentToolAppointmentBookPost.useMutationState({
     *     filters: {
     *         parameters: {}
     *     },
     *     select: mutation => mutation.state.data
     * })
     * ```
     */
    useMutationState<
      TContext = unknown,
      TResult = MutationState<
        BookAppointmentEndpointAgentToolAppointmentBookPostData,
        OperationError<BookAppointmentEndpointAgentToolAppointmentBookPostError>,
        MutationVariables<
          BookAppointmentEndpointAgentToolAppointmentBookPostBody,
          BookAppointmentEndpointAgentToolAppointmentBookPostParameters
        >,
        TContext
      >,
    >(options?: {
      filters?:
        | MutationFiltersByParameters<
            BookAppointmentEndpointAgentToolAppointmentBookPostBody,
            BookAppointmentEndpointAgentToolAppointmentBookPostData,
            BookAppointmentEndpointAgentToolAppointmentBookPostParameters,
            OperationError<BookAppointmentEndpointAgentToolAppointmentBookPostError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            BookAppointmentEndpointAgentToolAppointmentBookPostSchema,
            BookAppointmentEndpointAgentToolAppointmentBookPostBody,
            BookAppointmentEndpointAgentToolAppointmentBookPostData,
            BookAppointmentEndpointAgentToolAppointmentBookPostParameters,
            OperationError<BookAppointmentEndpointAgentToolAppointmentBookPostError>,
            TContext
          >;
      select?: (
        mutation: Mutation<
          BookAppointmentEndpointAgentToolAppointmentBookPostData,
          OperationError<BookAppointmentEndpointAgentToolAppointmentBookPostError>,
          MutationVariables<
            BookAppointmentEndpointAgentToolAppointmentBookPostBody,
            BookAppointmentEndpointAgentToolAppointmentBookPostParameters
          >,
          TContext
        >
      ) => TResult;
    }): Array<TResult>;
    /**
     * @summary Book Appointment Endpoint
     * @description Book a new appointment for a customer.
     */
    isMutating<TContext>(
      filters?:
        | MutationFiltersByParameters<
            BookAppointmentEndpointAgentToolAppointmentBookPostBody,
            BookAppointmentEndpointAgentToolAppointmentBookPostData,
            BookAppointmentEndpointAgentToolAppointmentBookPostParameters,
            OperationError<BookAppointmentEndpointAgentToolAppointmentBookPostError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            BookAppointmentEndpointAgentToolAppointmentBookPostSchema,
            BookAppointmentEndpointAgentToolAppointmentBookPostBody,
            BookAppointmentEndpointAgentToolAppointmentBookPostData,
            BookAppointmentEndpointAgentToolAppointmentBookPostParameters,
            OperationError<BookAppointmentEndpointAgentToolAppointmentBookPostError>,
            TContext
          >
    ): number;
    /**
     * Returns a `MutationCache` object that provides access to mutation cache operations
     * for the specific endpoint.
     *
     * @summary Book Appointment Endpoint
     * @description Book a new appointment for a customer.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/query-client/getMutationCache|`getMutationCache(...)` documentation}
     *
     * @example Find a mutation with specific parameters
     * ```ts
     * const mutationCache = qraft.agentToolsService.bookAppointmentEndpointAgentToolAppointmentBookPost.getMutationCache();
     * const mutation = mutationCache.find({
     *     parameters: {}
     * });
     * ```
     *
     * @example Find all mutations for the endpoint
     * ```ts
     * const mutationCache = qraft.agentToolsService.bookAppointmentEndpointAgentToolAppointmentBookPost.getMutationCache();
     * const mutations = mutationCache.findAll();
     * ```
     */
    getMutationCache(): Omit<MutationCache, 'find' | 'findAll'> & {
      find<TContext = unknown>(
        filters:
          | MutationFiltersByParameters<
              BookAppointmentEndpointAgentToolAppointmentBookPostBody,
              BookAppointmentEndpointAgentToolAppointmentBookPostData,
              BookAppointmentEndpointAgentToolAppointmentBookPostParameters,
              OperationError<BookAppointmentEndpointAgentToolAppointmentBookPostError>,
              TContext
            >
          | MutationFiltersByMutationKey<
              BookAppointmentEndpointAgentToolAppointmentBookPostSchema,
              BookAppointmentEndpointAgentToolAppointmentBookPostBody,
              BookAppointmentEndpointAgentToolAppointmentBookPostData,
              BookAppointmentEndpointAgentToolAppointmentBookPostParameters,
              OperationError<BookAppointmentEndpointAgentToolAppointmentBookPostError>,
              TContext
            >
      ):
        | Mutation<
            BookAppointmentEndpointAgentToolAppointmentBookPostData,
            BookAppointmentEndpointAgentToolAppointmentBookPostError,
            MutationVariables<
              BookAppointmentEndpointAgentToolAppointmentBookPostBody,
              BookAppointmentEndpointAgentToolAppointmentBookPostParameters
            >,
            TContext
          >
        | undefined;
      findAll<TContext = unknown>(
        filters?:
          | MutationFiltersByParameters<
              BookAppointmentEndpointAgentToolAppointmentBookPostBody,
              BookAppointmentEndpointAgentToolAppointmentBookPostData,
              BookAppointmentEndpointAgentToolAppointmentBookPostParameters,
              OperationError<BookAppointmentEndpointAgentToolAppointmentBookPostError>,
              TContext
            >
          | MutationFiltersByMutationKey<
              BookAppointmentEndpointAgentToolAppointmentBookPostSchema,
              BookAppointmentEndpointAgentToolAppointmentBookPostBody,
              BookAppointmentEndpointAgentToolAppointmentBookPostData,
              BookAppointmentEndpointAgentToolAppointmentBookPostParameters,
              OperationError<BookAppointmentEndpointAgentToolAppointmentBookPostError>,
              TContext
            >
      ): Array<
        Mutation<
          BookAppointmentEndpointAgentToolAppointmentBookPostData,
          BookAppointmentEndpointAgentToolAppointmentBookPostError,
          MutationVariables<
            BookAppointmentEndpointAgentToolAppointmentBookPostBody,
            BookAppointmentEndpointAgentToolAppointmentBookPostParameters
          >,
          TContext
        >
      >;
    };
    schema: BookAppointmentEndpointAgentToolAppointmentBookPostSchema;
    types: {
      parameters: BookAppointmentEndpointAgentToolAppointmentBookPostParameters;
      data: BookAppointmentEndpointAgentToolAppointmentBookPostData;
      error: BookAppointmentEndpointAgentToolAppointmentBookPostError;
      body: BookAppointmentEndpointAgentToolAppointmentBookPostBody;
    };
  };
  /**
   * @summary Reschedule Appointment Endpoint
   * @description Reschedule an existing appointment.
   */
  rescheduleAppointmentEndpointAgentToolAppointmentReschedulePost: {
    /**
     * @summary Reschedule Appointment Endpoint
     * @description Reschedule an existing appointment.
     */
    <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(
      options: ServiceOperationMutationFnOptions<
        RescheduleAppointmentEndpointAgentToolAppointmentReschedulePostBody,
        RescheduleAppointmentEndpointAgentToolAppointmentReschedulePostParameters,
        TMeta,
        TSignal
      >,
      client?: (
        schema: RescheduleAppointmentEndpointAgentToolAppointmentReschedulePostSchema,
        options: ServiceOperationMutationFnOptions<
          RescheduleAppointmentEndpointAgentToolAppointmentReschedulePostBody,
          RescheduleAppointmentEndpointAgentToolAppointmentReschedulePostParameters,
          TMeta,
          TSignal
        >
      ) => Promise<
        RequestFnResponse<
          RescheduleAppointmentEndpointAgentToolAppointmentReschedulePostData,
          RescheduleAppointmentEndpointAgentToolAppointmentReschedulePostError
        >
      >
    ): Promise<
      RequestFnResponse<
        RescheduleAppointmentEndpointAgentToolAppointmentReschedulePostData,
        RescheduleAppointmentEndpointAgentToolAppointmentReschedulePostError
      >
    >;
    /**
     * @summary Reschedule Appointment Endpoint
     * @description Reschedule an existing appointment.
     */
    getMutationKey(
      parameters: DeepReadonly<RescheduleAppointmentEndpointAgentToolAppointmentReschedulePostParameters> | void
    ): ServiceOperationMutationKey<
      RescheduleAppointmentEndpointAgentToolAppointmentReschedulePostSchema,
      RescheduleAppointmentEndpointAgentToolAppointmentReschedulePostParameters
    >;
    /**
     * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
     * Handles loading state, optimistic updates, and error handling.
     *
     * @summary Reschedule Appointment Endpoint
     * @description Reschedule an existing appointment.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
     * @example Mutation with predefined parameters, e.g., for updating
     * ```ts
     * const { mutate, isPending } = qraft.agentToolsService.rescheduleAppointmentEndpointAgentToolAppointmentReschedulePost.useMutation({})
     * mutate(body);
     * ```
     * @example Mutation without predefined parameters, e.g., for creating
     * ```ts
     * const { mutate, isPending } = qraft.agentToolsService.rescheduleAppointmentEndpointAgentToolAppointmentReschedulePost.useMutation()
     * mutate({
     *     body: bodyPayload
     * });
     * ```
     */
    useMutation<
      TVariables extends RescheduleAppointmentEndpointAgentToolAppointmentReschedulePostBody,
      TContext = unknown,
    >(
      parameters: DeepReadonly<RescheduleAppointmentEndpointAgentToolAppointmentReschedulePostParameters>,
      options?: ServiceOperationUseMutationOptions<
        RescheduleAppointmentEndpointAgentToolAppointmentReschedulePostSchema,
        RescheduleAppointmentEndpointAgentToolAppointmentReschedulePostData,
        RescheduleAppointmentEndpointAgentToolAppointmentReschedulePostParameters,
        TVariables,
        OperationError<RescheduleAppointmentEndpointAgentToolAppointmentReschedulePostError>,
        TContext
      >
    ): UseMutationResult<
      RescheduleAppointmentEndpointAgentToolAppointmentReschedulePostData,
      OperationError<RescheduleAppointmentEndpointAgentToolAppointmentReschedulePostError>,
      TVariables,
      TContext
    >;
    /**
     * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
     * Handles loading state, optimistic updates, and error handling.
     *
     * @summary Reschedule Appointment Endpoint
     * @description Reschedule an existing appointment.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
     * @example Mutation with predefined parameters, e.g., for updating
     * ```ts
     * const { mutate, isPending } = qraft.agentToolsService.rescheduleAppointmentEndpointAgentToolAppointmentReschedulePost.useMutation({})
     * mutate(body);
     * ```
     * @example Mutation without predefined parameters, e.g., for creating
     * ```ts
     * const { mutate, isPending } = qraft.agentToolsService.rescheduleAppointmentEndpointAgentToolAppointmentReschedulePost.useMutation()
     * mutate({
     *     body: bodyPayload
     * });
     * ```
     */
    useMutation<
      TVariables extends MutationVariables<
        RescheduleAppointmentEndpointAgentToolAppointmentReschedulePostBody,
        RescheduleAppointmentEndpointAgentToolAppointmentReschedulePostParameters
      >,
      TContext = unknown,
    >(
      parameters: void,
      options?: ServiceOperationUseMutationOptions<
        RescheduleAppointmentEndpointAgentToolAppointmentReschedulePostSchema,
        RescheduleAppointmentEndpointAgentToolAppointmentReschedulePostData,
        RescheduleAppointmentEndpointAgentToolAppointmentReschedulePostParameters,
        TVariables,
        OperationError<RescheduleAppointmentEndpointAgentToolAppointmentReschedulePostError>,
        TContext
      >
    ): UseMutationResult<
      RescheduleAppointmentEndpointAgentToolAppointmentReschedulePostData,
      OperationError<RescheduleAppointmentEndpointAgentToolAppointmentReschedulePostError>,
      TVariables,
      TContext
    >;
    /**
     * Returns the count of currently in-progress mutations.
     *
     * @summary Reschedule Appointment Endpoint
     * @description Reschedule an existing appointment.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsMutating|`useIsMutating(...)` documentation}
     * @example Check how many mutations are currently in progress for the specified service method.
     * ```ts
     * const rescheduleAppointmentEndpointAgentToolAppointmentReschedulePostTotal = qraft.agentToolsService.rescheduleAppointmentEndpointAgentToolAppointmentReschedulePost.useIsMutating()
     * ```
     * @example Check how many mutations are currently in progress with the specified parameters.
     * ```ts
     * const rescheduleAppointmentEndpointAgentToolAppointmentReschedulePostTotal = qraft.agentToolsService.rescheduleAppointmentEndpointAgentToolAppointmentReschedulePost.useIsMutating({
     *     parameters: {}
     * })
     * ```
     */
    useIsMutating<TContext = unknown>(
      filters?:
        | MutationFiltersByParameters<
            RescheduleAppointmentEndpointAgentToolAppointmentReschedulePostBody,
            RescheduleAppointmentEndpointAgentToolAppointmentReschedulePostData,
            RescheduleAppointmentEndpointAgentToolAppointmentReschedulePostParameters,
            OperationError<RescheduleAppointmentEndpointAgentToolAppointmentReschedulePostError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            RescheduleAppointmentEndpointAgentToolAppointmentReschedulePostSchema,
            RescheduleAppointmentEndpointAgentToolAppointmentReschedulePostBody,
            RescheduleAppointmentEndpointAgentToolAppointmentReschedulePostData,
            RescheduleAppointmentEndpointAgentToolAppointmentReschedulePostParameters,
            OperationError<RescheduleAppointmentEndpointAgentToolAppointmentReschedulePostError>,
            TContext
          >
    ): number;
    /**
     * Provides access to the current state of a mutation, including its status, any resulting data, and associated errors.
     *
     * @summary Reschedule Appointment Endpoint
     * @description Reschedule an existing appointment.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutationState|`useMutationState(...)` documentation}
     * @example Get all variables of all running mutations.
     * ```ts
     * const rescheduleAppointmentEndpointAgentToolAppointmentReschedulePostPendingMutationVariables = qraft.agentToolsService.rescheduleAppointmentEndpointAgentToolAppointmentReschedulePost.useMutationState({
     *     filters: {
     *         status: "pending"
     *     },
     *     select: mutation => mutation.state.variables
     * })
     * ```
     * @example Get all data for specific mutations via the `parameters`.
     * ```ts
     * const rescheduleAppointmentEndpointAgentToolAppointmentReschedulePostMutationData = qraft.agentToolsService.rescheduleAppointmentEndpointAgentToolAppointmentReschedulePost.useMutationState({
     *     filters: {
     *         parameters: {}
     *     },
     *     select: mutation => mutation.state.data
     * })
     * ```
     */
    useMutationState<
      TContext = unknown,
      TResult = MutationState<
        RescheduleAppointmentEndpointAgentToolAppointmentReschedulePostData,
        OperationError<RescheduleAppointmentEndpointAgentToolAppointmentReschedulePostError>,
        MutationVariables<
          RescheduleAppointmentEndpointAgentToolAppointmentReschedulePostBody,
          RescheduleAppointmentEndpointAgentToolAppointmentReschedulePostParameters
        >,
        TContext
      >,
    >(options?: {
      filters?:
        | MutationFiltersByParameters<
            RescheduleAppointmentEndpointAgentToolAppointmentReschedulePostBody,
            RescheduleAppointmentEndpointAgentToolAppointmentReschedulePostData,
            RescheduleAppointmentEndpointAgentToolAppointmentReschedulePostParameters,
            OperationError<RescheduleAppointmentEndpointAgentToolAppointmentReschedulePostError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            RescheduleAppointmentEndpointAgentToolAppointmentReschedulePostSchema,
            RescheduleAppointmentEndpointAgentToolAppointmentReschedulePostBody,
            RescheduleAppointmentEndpointAgentToolAppointmentReschedulePostData,
            RescheduleAppointmentEndpointAgentToolAppointmentReschedulePostParameters,
            OperationError<RescheduleAppointmentEndpointAgentToolAppointmentReschedulePostError>,
            TContext
          >;
      select?: (
        mutation: Mutation<
          RescheduleAppointmentEndpointAgentToolAppointmentReschedulePostData,
          OperationError<RescheduleAppointmentEndpointAgentToolAppointmentReschedulePostError>,
          MutationVariables<
            RescheduleAppointmentEndpointAgentToolAppointmentReschedulePostBody,
            RescheduleAppointmentEndpointAgentToolAppointmentReschedulePostParameters
          >,
          TContext
        >
      ) => TResult;
    }): Array<TResult>;
    /**
     * @summary Reschedule Appointment Endpoint
     * @description Reschedule an existing appointment.
     */
    isMutating<TContext>(
      filters?:
        | MutationFiltersByParameters<
            RescheduleAppointmentEndpointAgentToolAppointmentReschedulePostBody,
            RescheduleAppointmentEndpointAgentToolAppointmentReschedulePostData,
            RescheduleAppointmentEndpointAgentToolAppointmentReschedulePostParameters,
            OperationError<RescheduleAppointmentEndpointAgentToolAppointmentReschedulePostError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            RescheduleAppointmentEndpointAgentToolAppointmentReschedulePostSchema,
            RescheduleAppointmentEndpointAgentToolAppointmentReschedulePostBody,
            RescheduleAppointmentEndpointAgentToolAppointmentReschedulePostData,
            RescheduleAppointmentEndpointAgentToolAppointmentReschedulePostParameters,
            OperationError<RescheduleAppointmentEndpointAgentToolAppointmentReschedulePostError>,
            TContext
          >
    ): number;
    /**
     * Returns a `MutationCache` object that provides access to mutation cache operations
     * for the specific endpoint.
     *
     * @summary Reschedule Appointment Endpoint
     * @description Reschedule an existing appointment.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/query-client/getMutationCache|`getMutationCache(...)` documentation}
     *
     * @example Find a mutation with specific parameters
     * ```ts
     * const mutationCache = qraft.agentToolsService.rescheduleAppointmentEndpointAgentToolAppointmentReschedulePost.getMutationCache();
     * const mutation = mutationCache.find({
     *     parameters: {}
     * });
     * ```
     *
     * @example Find all mutations for the endpoint
     * ```ts
     * const mutationCache = qraft.agentToolsService.rescheduleAppointmentEndpointAgentToolAppointmentReschedulePost.getMutationCache();
     * const mutations = mutationCache.findAll();
     * ```
     */
    getMutationCache(): Omit<MutationCache, 'find' | 'findAll'> & {
      find<TContext = unknown>(
        filters:
          | MutationFiltersByParameters<
              RescheduleAppointmentEndpointAgentToolAppointmentReschedulePostBody,
              RescheduleAppointmentEndpointAgentToolAppointmentReschedulePostData,
              RescheduleAppointmentEndpointAgentToolAppointmentReschedulePostParameters,
              OperationError<RescheduleAppointmentEndpointAgentToolAppointmentReschedulePostError>,
              TContext
            >
          | MutationFiltersByMutationKey<
              RescheduleAppointmentEndpointAgentToolAppointmentReschedulePostSchema,
              RescheduleAppointmentEndpointAgentToolAppointmentReschedulePostBody,
              RescheduleAppointmentEndpointAgentToolAppointmentReschedulePostData,
              RescheduleAppointmentEndpointAgentToolAppointmentReschedulePostParameters,
              OperationError<RescheduleAppointmentEndpointAgentToolAppointmentReschedulePostError>,
              TContext
            >
      ):
        | Mutation<
            RescheduleAppointmentEndpointAgentToolAppointmentReschedulePostData,
            RescheduleAppointmentEndpointAgentToolAppointmentReschedulePostError,
            MutationVariables<
              RescheduleAppointmentEndpointAgentToolAppointmentReschedulePostBody,
              RescheduleAppointmentEndpointAgentToolAppointmentReschedulePostParameters
            >,
            TContext
          >
        | undefined;
      findAll<TContext = unknown>(
        filters?:
          | MutationFiltersByParameters<
              RescheduleAppointmentEndpointAgentToolAppointmentReschedulePostBody,
              RescheduleAppointmentEndpointAgentToolAppointmentReschedulePostData,
              RescheduleAppointmentEndpointAgentToolAppointmentReschedulePostParameters,
              OperationError<RescheduleAppointmentEndpointAgentToolAppointmentReschedulePostError>,
              TContext
            >
          | MutationFiltersByMutationKey<
              RescheduleAppointmentEndpointAgentToolAppointmentReschedulePostSchema,
              RescheduleAppointmentEndpointAgentToolAppointmentReschedulePostBody,
              RescheduleAppointmentEndpointAgentToolAppointmentReschedulePostData,
              RescheduleAppointmentEndpointAgentToolAppointmentReschedulePostParameters,
              OperationError<RescheduleAppointmentEndpointAgentToolAppointmentReschedulePostError>,
              TContext
            >
      ): Array<
        Mutation<
          RescheduleAppointmentEndpointAgentToolAppointmentReschedulePostData,
          RescheduleAppointmentEndpointAgentToolAppointmentReschedulePostError,
          MutationVariables<
            RescheduleAppointmentEndpointAgentToolAppointmentReschedulePostBody,
            RescheduleAppointmentEndpointAgentToolAppointmentReschedulePostParameters
          >,
          TContext
        >
      >;
    };
    schema: RescheduleAppointmentEndpointAgentToolAppointmentReschedulePostSchema;
    types: {
      parameters: RescheduleAppointmentEndpointAgentToolAppointmentReschedulePostParameters;
      data: RescheduleAppointmentEndpointAgentToolAppointmentReschedulePostData;
      error: RescheduleAppointmentEndpointAgentToolAppointmentReschedulePostError;
      body: RescheduleAppointmentEndpointAgentToolAppointmentReschedulePostBody;
    };
  };
  /**
   * @summary Cancel Appointment Endpoint
   * @description Cancel an appointment.
   */
  cancelAppointmentEndpointAgentToolAppointmentCancelPost: {
    /**
     * @summary Cancel Appointment Endpoint
     * @description Cancel an appointment.
     */
    <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(
      options: ServiceOperationMutationFnOptions<
        CancelAppointmentEndpointAgentToolAppointmentCancelPostBody,
        CancelAppointmentEndpointAgentToolAppointmentCancelPostParameters,
        TMeta,
        TSignal
      >,
      client?: (
        schema: CancelAppointmentEndpointAgentToolAppointmentCancelPostSchema,
        options: ServiceOperationMutationFnOptions<
          CancelAppointmentEndpointAgentToolAppointmentCancelPostBody,
          CancelAppointmentEndpointAgentToolAppointmentCancelPostParameters,
          TMeta,
          TSignal
        >
      ) => Promise<
        RequestFnResponse<
          CancelAppointmentEndpointAgentToolAppointmentCancelPostData,
          CancelAppointmentEndpointAgentToolAppointmentCancelPostError
        >
      >
    ): Promise<
      RequestFnResponse<
        CancelAppointmentEndpointAgentToolAppointmentCancelPostData,
        CancelAppointmentEndpointAgentToolAppointmentCancelPostError
      >
    >;
    /**
     * @summary Cancel Appointment Endpoint
     * @description Cancel an appointment.
     */
    getMutationKey(
      parameters: DeepReadonly<CancelAppointmentEndpointAgentToolAppointmentCancelPostParameters> | void
    ): ServiceOperationMutationKey<
      CancelAppointmentEndpointAgentToolAppointmentCancelPostSchema,
      CancelAppointmentEndpointAgentToolAppointmentCancelPostParameters
    >;
    /**
     * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
     * Handles loading state, optimistic updates, and error handling.
     *
     * @summary Cancel Appointment Endpoint
     * @description Cancel an appointment.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
     * @example Mutation with predefined parameters, e.g., for updating
     * ```ts
     * const { mutate, isPending } = qraft.agentToolsService.cancelAppointmentEndpointAgentToolAppointmentCancelPost.useMutation({})
     * mutate(body);
     * ```
     * @example Mutation without predefined parameters, e.g., for creating
     * ```ts
     * const { mutate, isPending } = qraft.agentToolsService.cancelAppointmentEndpointAgentToolAppointmentCancelPost.useMutation()
     * mutate({
     *     body: bodyPayload
     * });
     * ```
     */
    useMutation<TVariables extends CancelAppointmentEndpointAgentToolAppointmentCancelPostBody, TContext = unknown>(
      parameters: DeepReadonly<CancelAppointmentEndpointAgentToolAppointmentCancelPostParameters>,
      options?: ServiceOperationUseMutationOptions<
        CancelAppointmentEndpointAgentToolAppointmentCancelPostSchema,
        CancelAppointmentEndpointAgentToolAppointmentCancelPostData,
        CancelAppointmentEndpointAgentToolAppointmentCancelPostParameters,
        TVariables,
        OperationError<CancelAppointmentEndpointAgentToolAppointmentCancelPostError>,
        TContext
      >
    ): UseMutationResult<
      CancelAppointmentEndpointAgentToolAppointmentCancelPostData,
      OperationError<CancelAppointmentEndpointAgentToolAppointmentCancelPostError>,
      TVariables,
      TContext
    >;
    /**
     * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
     * Handles loading state, optimistic updates, and error handling.
     *
     * @summary Cancel Appointment Endpoint
     * @description Cancel an appointment.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
     * @example Mutation with predefined parameters, e.g., for updating
     * ```ts
     * const { mutate, isPending } = qraft.agentToolsService.cancelAppointmentEndpointAgentToolAppointmentCancelPost.useMutation({})
     * mutate(body);
     * ```
     * @example Mutation without predefined parameters, e.g., for creating
     * ```ts
     * const { mutate, isPending } = qraft.agentToolsService.cancelAppointmentEndpointAgentToolAppointmentCancelPost.useMutation()
     * mutate({
     *     body: bodyPayload
     * });
     * ```
     */
    useMutation<
      TVariables extends MutationVariables<
        CancelAppointmentEndpointAgentToolAppointmentCancelPostBody,
        CancelAppointmentEndpointAgentToolAppointmentCancelPostParameters
      >,
      TContext = unknown,
    >(
      parameters: void,
      options?: ServiceOperationUseMutationOptions<
        CancelAppointmentEndpointAgentToolAppointmentCancelPostSchema,
        CancelAppointmentEndpointAgentToolAppointmentCancelPostData,
        CancelAppointmentEndpointAgentToolAppointmentCancelPostParameters,
        TVariables,
        OperationError<CancelAppointmentEndpointAgentToolAppointmentCancelPostError>,
        TContext
      >
    ): UseMutationResult<
      CancelAppointmentEndpointAgentToolAppointmentCancelPostData,
      OperationError<CancelAppointmentEndpointAgentToolAppointmentCancelPostError>,
      TVariables,
      TContext
    >;
    /**
     * Returns the count of currently in-progress mutations.
     *
     * @summary Cancel Appointment Endpoint
     * @description Cancel an appointment.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsMutating|`useIsMutating(...)` documentation}
     * @example Check how many mutations are currently in progress for the specified service method.
     * ```ts
     * const cancelAppointmentEndpointAgentToolAppointmentCancelPostTotal = qraft.agentToolsService.cancelAppointmentEndpointAgentToolAppointmentCancelPost.useIsMutating()
     * ```
     * @example Check how many mutations are currently in progress with the specified parameters.
     * ```ts
     * const cancelAppointmentEndpointAgentToolAppointmentCancelPostTotal = qraft.agentToolsService.cancelAppointmentEndpointAgentToolAppointmentCancelPost.useIsMutating({
     *     parameters: {}
     * })
     * ```
     */
    useIsMutating<TContext = unknown>(
      filters?:
        | MutationFiltersByParameters<
            CancelAppointmentEndpointAgentToolAppointmentCancelPostBody,
            CancelAppointmentEndpointAgentToolAppointmentCancelPostData,
            CancelAppointmentEndpointAgentToolAppointmentCancelPostParameters,
            OperationError<CancelAppointmentEndpointAgentToolAppointmentCancelPostError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            CancelAppointmentEndpointAgentToolAppointmentCancelPostSchema,
            CancelAppointmentEndpointAgentToolAppointmentCancelPostBody,
            CancelAppointmentEndpointAgentToolAppointmentCancelPostData,
            CancelAppointmentEndpointAgentToolAppointmentCancelPostParameters,
            OperationError<CancelAppointmentEndpointAgentToolAppointmentCancelPostError>,
            TContext
          >
    ): number;
    /**
     * Provides access to the current state of a mutation, including its status, any resulting data, and associated errors.
     *
     * @summary Cancel Appointment Endpoint
     * @description Cancel an appointment.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutationState|`useMutationState(...)` documentation}
     * @example Get all variables of all running mutations.
     * ```ts
     * const cancelAppointmentEndpointAgentToolAppointmentCancelPostPendingMutationVariables = qraft.agentToolsService.cancelAppointmentEndpointAgentToolAppointmentCancelPost.useMutationState({
     *     filters: {
     *         status: "pending"
     *     },
     *     select: mutation => mutation.state.variables
     * })
     * ```
     * @example Get all data for specific mutations via the `parameters`.
     * ```ts
     * const cancelAppointmentEndpointAgentToolAppointmentCancelPostMutationData = qraft.agentToolsService.cancelAppointmentEndpointAgentToolAppointmentCancelPost.useMutationState({
     *     filters: {
     *         parameters: {}
     *     },
     *     select: mutation => mutation.state.data
     * })
     * ```
     */
    useMutationState<
      TContext = unknown,
      TResult = MutationState<
        CancelAppointmentEndpointAgentToolAppointmentCancelPostData,
        OperationError<CancelAppointmentEndpointAgentToolAppointmentCancelPostError>,
        MutationVariables<
          CancelAppointmentEndpointAgentToolAppointmentCancelPostBody,
          CancelAppointmentEndpointAgentToolAppointmentCancelPostParameters
        >,
        TContext
      >,
    >(options?: {
      filters?:
        | MutationFiltersByParameters<
            CancelAppointmentEndpointAgentToolAppointmentCancelPostBody,
            CancelAppointmentEndpointAgentToolAppointmentCancelPostData,
            CancelAppointmentEndpointAgentToolAppointmentCancelPostParameters,
            OperationError<CancelAppointmentEndpointAgentToolAppointmentCancelPostError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            CancelAppointmentEndpointAgentToolAppointmentCancelPostSchema,
            CancelAppointmentEndpointAgentToolAppointmentCancelPostBody,
            CancelAppointmentEndpointAgentToolAppointmentCancelPostData,
            CancelAppointmentEndpointAgentToolAppointmentCancelPostParameters,
            OperationError<CancelAppointmentEndpointAgentToolAppointmentCancelPostError>,
            TContext
          >;
      select?: (
        mutation: Mutation<
          CancelAppointmentEndpointAgentToolAppointmentCancelPostData,
          OperationError<CancelAppointmentEndpointAgentToolAppointmentCancelPostError>,
          MutationVariables<
            CancelAppointmentEndpointAgentToolAppointmentCancelPostBody,
            CancelAppointmentEndpointAgentToolAppointmentCancelPostParameters
          >,
          TContext
        >
      ) => TResult;
    }): Array<TResult>;
    /**
     * @summary Cancel Appointment Endpoint
     * @description Cancel an appointment.
     */
    isMutating<TContext>(
      filters?:
        | MutationFiltersByParameters<
            CancelAppointmentEndpointAgentToolAppointmentCancelPostBody,
            CancelAppointmentEndpointAgentToolAppointmentCancelPostData,
            CancelAppointmentEndpointAgentToolAppointmentCancelPostParameters,
            OperationError<CancelAppointmentEndpointAgentToolAppointmentCancelPostError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            CancelAppointmentEndpointAgentToolAppointmentCancelPostSchema,
            CancelAppointmentEndpointAgentToolAppointmentCancelPostBody,
            CancelAppointmentEndpointAgentToolAppointmentCancelPostData,
            CancelAppointmentEndpointAgentToolAppointmentCancelPostParameters,
            OperationError<CancelAppointmentEndpointAgentToolAppointmentCancelPostError>,
            TContext
          >
    ): number;
    /**
     * Returns a `MutationCache` object that provides access to mutation cache operations
     * for the specific endpoint.
     *
     * @summary Cancel Appointment Endpoint
     * @description Cancel an appointment.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/query-client/getMutationCache|`getMutationCache(...)` documentation}
     *
     * @example Find a mutation with specific parameters
     * ```ts
     * const mutationCache = qraft.agentToolsService.cancelAppointmentEndpointAgentToolAppointmentCancelPost.getMutationCache();
     * const mutation = mutationCache.find({
     *     parameters: {}
     * });
     * ```
     *
     * @example Find all mutations for the endpoint
     * ```ts
     * const mutationCache = qraft.agentToolsService.cancelAppointmentEndpointAgentToolAppointmentCancelPost.getMutationCache();
     * const mutations = mutationCache.findAll();
     * ```
     */
    getMutationCache(): Omit<MutationCache, 'find' | 'findAll'> & {
      find<TContext = unknown>(
        filters:
          | MutationFiltersByParameters<
              CancelAppointmentEndpointAgentToolAppointmentCancelPostBody,
              CancelAppointmentEndpointAgentToolAppointmentCancelPostData,
              CancelAppointmentEndpointAgentToolAppointmentCancelPostParameters,
              OperationError<CancelAppointmentEndpointAgentToolAppointmentCancelPostError>,
              TContext
            >
          | MutationFiltersByMutationKey<
              CancelAppointmentEndpointAgentToolAppointmentCancelPostSchema,
              CancelAppointmentEndpointAgentToolAppointmentCancelPostBody,
              CancelAppointmentEndpointAgentToolAppointmentCancelPostData,
              CancelAppointmentEndpointAgentToolAppointmentCancelPostParameters,
              OperationError<CancelAppointmentEndpointAgentToolAppointmentCancelPostError>,
              TContext
            >
      ):
        | Mutation<
            CancelAppointmentEndpointAgentToolAppointmentCancelPostData,
            CancelAppointmentEndpointAgentToolAppointmentCancelPostError,
            MutationVariables<
              CancelAppointmentEndpointAgentToolAppointmentCancelPostBody,
              CancelAppointmentEndpointAgentToolAppointmentCancelPostParameters
            >,
            TContext
          >
        | undefined;
      findAll<TContext = unknown>(
        filters?:
          | MutationFiltersByParameters<
              CancelAppointmentEndpointAgentToolAppointmentCancelPostBody,
              CancelAppointmentEndpointAgentToolAppointmentCancelPostData,
              CancelAppointmentEndpointAgentToolAppointmentCancelPostParameters,
              OperationError<CancelAppointmentEndpointAgentToolAppointmentCancelPostError>,
              TContext
            >
          | MutationFiltersByMutationKey<
              CancelAppointmentEndpointAgentToolAppointmentCancelPostSchema,
              CancelAppointmentEndpointAgentToolAppointmentCancelPostBody,
              CancelAppointmentEndpointAgentToolAppointmentCancelPostData,
              CancelAppointmentEndpointAgentToolAppointmentCancelPostParameters,
              OperationError<CancelAppointmentEndpointAgentToolAppointmentCancelPostError>,
              TContext
            >
      ): Array<
        Mutation<
          CancelAppointmentEndpointAgentToolAppointmentCancelPostData,
          CancelAppointmentEndpointAgentToolAppointmentCancelPostError,
          MutationVariables<
            CancelAppointmentEndpointAgentToolAppointmentCancelPostBody,
            CancelAppointmentEndpointAgentToolAppointmentCancelPostParameters
          >,
          TContext
        >
      >;
    };
    schema: CancelAppointmentEndpointAgentToolAppointmentCancelPostSchema;
    types: {
      parameters: CancelAppointmentEndpointAgentToolAppointmentCancelPostParameters;
      data: CancelAppointmentEndpointAgentToolAppointmentCancelPostData;
      error: CancelAppointmentEndpointAgentToolAppointmentCancelPostError;
      body: CancelAppointmentEndpointAgentToolAppointmentCancelPostBody;
    };
  };
  /**
   * @summary Add Appointment Note Endpoint
   * @description Add a note to an appointment by appending to any existing notes.
   */
  addAppointmentNoteEndpointAgentToolAppointmentAddNotePost: {
    /**
     * @summary Add Appointment Note Endpoint
     * @description Add a note to an appointment by appending to any existing notes.
     */
    <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(
      options: ServiceOperationMutationFnOptions<
        AddAppointmentNoteEndpointAgentToolAppointmentAddNotePostBody,
        AddAppointmentNoteEndpointAgentToolAppointmentAddNotePostParameters,
        TMeta,
        TSignal
      >,
      client?: (
        schema: AddAppointmentNoteEndpointAgentToolAppointmentAddNotePostSchema,
        options: ServiceOperationMutationFnOptions<
          AddAppointmentNoteEndpointAgentToolAppointmentAddNotePostBody,
          AddAppointmentNoteEndpointAgentToolAppointmentAddNotePostParameters,
          TMeta,
          TSignal
        >
      ) => Promise<
        RequestFnResponse<
          AddAppointmentNoteEndpointAgentToolAppointmentAddNotePostData,
          AddAppointmentNoteEndpointAgentToolAppointmentAddNotePostError
        >
      >
    ): Promise<
      RequestFnResponse<
        AddAppointmentNoteEndpointAgentToolAppointmentAddNotePostData,
        AddAppointmentNoteEndpointAgentToolAppointmentAddNotePostError
      >
    >;
    /**
     * @summary Add Appointment Note Endpoint
     * @description Add a note to an appointment by appending to any existing notes.
     */
    getMutationKey(
      parameters: DeepReadonly<AddAppointmentNoteEndpointAgentToolAppointmentAddNotePostParameters> | void
    ): ServiceOperationMutationKey<
      AddAppointmentNoteEndpointAgentToolAppointmentAddNotePostSchema,
      AddAppointmentNoteEndpointAgentToolAppointmentAddNotePostParameters
    >;
    /**
     * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
     * Handles loading state, optimistic updates, and error handling.
     *
     * @summary Add Appointment Note Endpoint
     * @description Add a note to an appointment by appending to any existing notes.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
     * @example Mutation with predefined parameters, e.g., for updating
     * ```ts
     * const { mutate, isPending } = qraft.agentToolsService.addAppointmentNoteEndpointAgentToolAppointmentAddNotePost.useMutation({})
     * mutate(body);
     * ```
     * @example Mutation without predefined parameters, e.g., for creating
     * ```ts
     * const { mutate, isPending } = qraft.agentToolsService.addAppointmentNoteEndpointAgentToolAppointmentAddNotePost.useMutation()
     * mutate({
     *     body: bodyPayload
     * });
     * ```
     */
    useMutation<TVariables extends AddAppointmentNoteEndpointAgentToolAppointmentAddNotePostBody, TContext = unknown>(
      parameters: DeepReadonly<AddAppointmentNoteEndpointAgentToolAppointmentAddNotePostParameters>,
      options?: ServiceOperationUseMutationOptions<
        AddAppointmentNoteEndpointAgentToolAppointmentAddNotePostSchema,
        AddAppointmentNoteEndpointAgentToolAppointmentAddNotePostData,
        AddAppointmentNoteEndpointAgentToolAppointmentAddNotePostParameters,
        TVariables,
        OperationError<AddAppointmentNoteEndpointAgentToolAppointmentAddNotePostError>,
        TContext
      >
    ): UseMutationResult<
      AddAppointmentNoteEndpointAgentToolAppointmentAddNotePostData,
      OperationError<AddAppointmentNoteEndpointAgentToolAppointmentAddNotePostError>,
      TVariables,
      TContext
    >;
    /**
     * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
     * Handles loading state, optimistic updates, and error handling.
     *
     * @summary Add Appointment Note Endpoint
     * @description Add a note to an appointment by appending to any existing notes.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
     * @example Mutation with predefined parameters, e.g., for updating
     * ```ts
     * const { mutate, isPending } = qraft.agentToolsService.addAppointmentNoteEndpointAgentToolAppointmentAddNotePost.useMutation({})
     * mutate(body);
     * ```
     * @example Mutation without predefined parameters, e.g., for creating
     * ```ts
     * const { mutate, isPending } = qraft.agentToolsService.addAppointmentNoteEndpointAgentToolAppointmentAddNotePost.useMutation()
     * mutate({
     *     body: bodyPayload
     * });
     * ```
     */
    useMutation<
      TVariables extends MutationVariables<
        AddAppointmentNoteEndpointAgentToolAppointmentAddNotePostBody,
        AddAppointmentNoteEndpointAgentToolAppointmentAddNotePostParameters
      >,
      TContext = unknown,
    >(
      parameters: void,
      options?: ServiceOperationUseMutationOptions<
        AddAppointmentNoteEndpointAgentToolAppointmentAddNotePostSchema,
        AddAppointmentNoteEndpointAgentToolAppointmentAddNotePostData,
        AddAppointmentNoteEndpointAgentToolAppointmentAddNotePostParameters,
        TVariables,
        OperationError<AddAppointmentNoteEndpointAgentToolAppointmentAddNotePostError>,
        TContext
      >
    ): UseMutationResult<
      AddAppointmentNoteEndpointAgentToolAppointmentAddNotePostData,
      OperationError<AddAppointmentNoteEndpointAgentToolAppointmentAddNotePostError>,
      TVariables,
      TContext
    >;
    /**
     * Returns the count of currently in-progress mutations.
     *
     * @summary Add Appointment Note Endpoint
     * @description Add a note to an appointment by appending to any existing notes.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsMutating|`useIsMutating(...)` documentation}
     * @example Check how many mutations are currently in progress for the specified service method.
     * ```ts
     * const addAppointmentNoteEndpointAgentToolAppointmentAddNotePostTotal = qraft.agentToolsService.addAppointmentNoteEndpointAgentToolAppointmentAddNotePost.useIsMutating()
     * ```
     * @example Check how many mutations are currently in progress with the specified parameters.
     * ```ts
     * const addAppointmentNoteEndpointAgentToolAppointmentAddNotePostTotal = qraft.agentToolsService.addAppointmentNoteEndpointAgentToolAppointmentAddNotePost.useIsMutating({
     *     parameters: {}
     * })
     * ```
     */
    useIsMutating<TContext = unknown>(
      filters?:
        | MutationFiltersByParameters<
            AddAppointmentNoteEndpointAgentToolAppointmentAddNotePostBody,
            AddAppointmentNoteEndpointAgentToolAppointmentAddNotePostData,
            AddAppointmentNoteEndpointAgentToolAppointmentAddNotePostParameters,
            OperationError<AddAppointmentNoteEndpointAgentToolAppointmentAddNotePostError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            AddAppointmentNoteEndpointAgentToolAppointmentAddNotePostSchema,
            AddAppointmentNoteEndpointAgentToolAppointmentAddNotePostBody,
            AddAppointmentNoteEndpointAgentToolAppointmentAddNotePostData,
            AddAppointmentNoteEndpointAgentToolAppointmentAddNotePostParameters,
            OperationError<AddAppointmentNoteEndpointAgentToolAppointmentAddNotePostError>,
            TContext
          >
    ): number;
    /**
     * Provides access to the current state of a mutation, including its status, any resulting data, and associated errors.
     *
     * @summary Add Appointment Note Endpoint
     * @description Add a note to an appointment by appending to any existing notes.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutationState|`useMutationState(...)` documentation}
     * @example Get all variables of all running mutations.
     * ```ts
     * const addAppointmentNoteEndpointAgentToolAppointmentAddNotePostPendingMutationVariables = qraft.agentToolsService.addAppointmentNoteEndpointAgentToolAppointmentAddNotePost.useMutationState({
     *     filters: {
     *         status: "pending"
     *     },
     *     select: mutation => mutation.state.variables
     * })
     * ```
     * @example Get all data for specific mutations via the `parameters`.
     * ```ts
     * const addAppointmentNoteEndpointAgentToolAppointmentAddNotePostMutationData = qraft.agentToolsService.addAppointmentNoteEndpointAgentToolAppointmentAddNotePost.useMutationState({
     *     filters: {
     *         parameters: {}
     *     },
     *     select: mutation => mutation.state.data
     * })
     * ```
     */
    useMutationState<
      TContext = unknown,
      TResult = MutationState<
        AddAppointmentNoteEndpointAgentToolAppointmentAddNotePostData,
        OperationError<AddAppointmentNoteEndpointAgentToolAppointmentAddNotePostError>,
        MutationVariables<
          AddAppointmentNoteEndpointAgentToolAppointmentAddNotePostBody,
          AddAppointmentNoteEndpointAgentToolAppointmentAddNotePostParameters
        >,
        TContext
      >,
    >(options?: {
      filters?:
        | MutationFiltersByParameters<
            AddAppointmentNoteEndpointAgentToolAppointmentAddNotePostBody,
            AddAppointmentNoteEndpointAgentToolAppointmentAddNotePostData,
            AddAppointmentNoteEndpointAgentToolAppointmentAddNotePostParameters,
            OperationError<AddAppointmentNoteEndpointAgentToolAppointmentAddNotePostError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            AddAppointmentNoteEndpointAgentToolAppointmentAddNotePostSchema,
            AddAppointmentNoteEndpointAgentToolAppointmentAddNotePostBody,
            AddAppointmentNoteEndpointAgentToolAppointmentAddNotePostData,
            AddAppointmentNoteEndpointAgentToolAppointmentAddNotePostParameters,
            OperationError<AddAppointmentNoteEndpointAgentToolAppointmentAddNotePostError>,
            TContext
          >;
      select?: (
        mutation: Mutation<
          AddAppointmentNoteEndpointAgentToolAppointmentAddNotePostData,
          OperationError<AddAppointmentNoteEndpointAgentToolAppointmentAddNotePostError>,
          MutationVariables<
            AddAppointmentNoteEndpointAgentToolAppointmentAddNotePostBody,
            AddAppointmentNoteEndpointAgentToolAppointmentAddNotePostParameters
          >,
          TContext
        >
      ) => TResult;
    }): Array<TResult>;
    /**
     * @summary Add Appointment Note Endpoint
     * @description Add a note to an appointment by appending to any existing notes.
     */
    isMutating<TContext>(
      filters?:
        | MutationFiltersByParameters<
            AddAppointmentNoteEndpointAgentToolAppointmentAddNotePostBody,
            AddAppointmentNoteEndpointAgentToolAppointmentAddNotePostData,
            AddAppointmentNoteEndpointAgentToolAppointmentAddNotePostParameters,
            OperationError<AddAppointmentNoteEndpointAgentToolAppointmentAddNotePostError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            AddAppointmentNoteEndpointAgentToolAppointmentAddNotePostSchema,
            AddAppointmentNoteEndpointAgentToolAppointmentAddNotePostBody,
            AddAppointmentNoteEndpointAgentToolAppointmentAddNotePostData,
            AddAppointmentNoteEndpointAgentToolAppointmentAddNotePostParameters,
            OperationError<AddAppointmentNoteEndpointAgentToolAppointmentAddNotePostError>,
            TContext
          >
    ): number;
    /**
     * Returns a `MutationCache` object that provides access to mutation cache operations
     * for the specific endpoint.
     *
     * @summary Add Appointment Note Endpoint
     * @description Add a note to an appointment by appending to any existing notes.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/query-client/getMutationCache|`getMutationCache(...)` documentation}
     *
     * @example Find a mutation with specific parameters
     * ```ts
     * const mutationCache = qraft.agentToolsService.addAppointmentNoteEndpointAgentToolAppointmentAddNotePost.getMutationCache();
     * const mutation = mutationCache.find({
     *     parameters: {}
     * });
     * ```
     *
     * @example Find all mutations for the endpoint
     * ```ts
     * const mutationCache = qraft.agentToolsService.addAppointmentNoteEndpointAgentToolAppointmentAddNotePost.getMutationCache();
     * const mutations = mutationCache.findAll();
     * ```
     */
    getMutationCache(): Omit<MutationCache, 'find' | 'findAll'> & {
      find<TContext = unknown>(
        filters:
          | MutationFiltersByParameters<
              AddAppointmentNoteEndpointAgentToolAppointmentAddNotePostBody,
              AddAppointmentNoteEndpointAgentToolAppointmentAddNotePostData,
              AddAppointmentNoteEndpointAgentToolAppointmentAddNotePostParameters,
              OperationError<AddAppointmentNoteEndpointAgentToolAppointmentAddNotePostError>,
              TContext
            >
          | MutationFiltersByMutationKey<
              AddAppointmentNoteEndpointAgentToolAppointmentAddNotePostSchema,
              AddAppointmentNoteEndpointAgentToolAppointmentAddNotePostBody,
              AddAppointmentNoteEndpointAgentToolAppointmentAddNotePostData,
              AddAppointmentNoteEndpointAgentToolAppointmentAddNotePostParameters,
              OperationError<AddAppointmentNoteEndpointAgentToolAppointmentAddNotePostError>,
              TContext
            >
      ):
        | Mutation<
            AddAppointmentNoteEndpointAgentToolAppointmentAddNotePostData,
            AddAppointmentNoteEndpointAgentToolAppointmentAddNotePostError,
            MutationVariables<
              AddAppointmentNoteEndpointAgentToolAppointmentAddNotePostBody,
              AddAppointmentNoteEndpointAgentToolAppointmentAddNotePostParameters
            >,
            TContext
          >
        | undefined;
      findAll<TContext = unknown>(
        filters?:
          | MutationFiltersByParameters<
              AddAppointmentNoteEndpointAgentToolAppointmentAddNotePostBody,
              AddAppointmentNoteEndpointAgentToolAppointmentAddNotePostData,
              AddAppointmentNoteEndpointAgentToolAppointmentAddNotePostParameters,
              OperationError<AddAppointmentNoteEndpointAgentToolAppointmentAddNotePostError>,
              TContext
            >
          | MutationFiltersByMutationKey<
              AddAppointmentNoteEndpointAgentToolAppointmentAddNotePostSchema,
              AddAppointmentNoteEndpointAgentToolAppointmentAddNotePostBody,
              AddAppointmentNoteEndpointAgentToolAppointmentAddNotePostData,
              AddAppointmentNoteEndpointAgentToolAppointmentAddNotePostParameters,
              OperationError<AddAppointmentNoteEndpointAgentToolAppointmentAddNotePostError>,
              TContext
            >
      ): Array<
        Mutation<
          AddAppointmentNoteEndpointAgentToolAppointmentAddNotePostData,
          AddAppointmentNoteEndpointAgentToolAppointmentAddNotePostError,
          MutationVariables<
            AddAppointmentNoteEndpointAgentToolAppointmentAddNotePostBody,
            AddAppointmentNoteEndpointAgentToolAppointmentAddNotePostParameters
          >,
          TContext
        >
      >;
    };
    schema: AddAppointmentNoteEndpointAgentToolAppointmentAddNotePostSchema;
    types: {
      parameters: AddAppointmentNoteEndpointAgentToolAppointmentAddNotePostParameters;
      data: AddAppointmentNoteEndpointAgentToolAppointmentAddNotePostData;
      error: AddAppointmentNoteEndpointAgentToolAppointmentAddNotePostError;
      body: AddAppointmentNoteEndpointAgentToolAppointmentAddNotePostBody;
    };
  };
}
/**
 * @summary Get Customers By Phone Endpoint
 * @description Get customers by phone number.
 *
 * Search for customers using their phone number. The phone number will be validated
 * and normalized to E164 format before searching.
 *
 * For testing in FastAPI docs:
 * 1. Ensure you have a valid retell_agent_id in the voice_agents table
 * 2. Include x-retell-signature header (for testing, you may need to disable signature verification)
 */
export const getCustomersByPhoneEndpointAgentToolCustomerGetByPhonePost = {
  schema: {
    method: 'post',
    url: '/agent/tool/customer/get_by_phone',
    mediaType: ['application/json'],
  },
} as {
  schema: GetCustomersByPhoneEndpointAgentToolCustomerGetByPhonePostSchema;
  [QraftServiceOperationsToken]: AgentToolsService['getCustomersByPhoneEndpointAgentToolCustomerGetByPhonePost'];
};
/**
 * @summary Get Customers By Zipcode Endpoint
 * @description Get customers by zipcode.
 *
 * Search for all customers in a specific ZIP code area.
 */
export const getCustomersByZipcodeEndpointAgentToolCustomerGetByZipcodePost = {
  schema: {
    method: 'post',
    url: '/agent/tool/customer/get_by_zipcode',
    mediaType: ['application/json'],
  },
} as {
  schema: GetCustomersByZipcodeEndpointAgentToolCustomerGetByZipcodePostSchema;
  [QraftServiceOperationsToken]: AgentToolsService['getCustomersByZipcodeEndpointAgentToolCustomerGetByZipcodePost'];
};
/**
 * @summary Search Customers By Address Endpoint
 * @description Search customers by address with fuzzy matching.
 *
 * Uses advanced fuzzy matching to find customers even with slight variations in address spelling.
 * Returns exact matches and similar addresses with similarity scores.
 */
export const searchCustomersByAddressEndpointAgentToolCustomerSearchByAddressPost = {
  schema: {
    method: 'post',
    url: '/agent/tool/customer/search_by_address',
    mediaType: ['application/json'],
  },
} as {
  schema: SearchCustomersByAddressEndpointAgentToolCustomerSearchByAddressPostSchema;
  [QraftServiceOperationsToken]: AgentToolsService['searchCustomersByAddressEndpointAgentToolCustomerSearchByAddressPost'];
};
/**
 * @summary Create Customer Endpoint
 * @description Create a new customer.
 *
 * Creates a new customer with contact information and optional address.
 */
export const createCustomerEndpointAgentToolCustomerCreatePost = {
  schema: {
    method: 'post',
    url: '/agent/tool/customer/create',
    mediaType: ['application/json'],
  },
} as {
  schema: CreateCustomerEndpointAgentToolCustomerCreatePostSchema;
  [QraftServiceOperationsToken]: AgentToolsService['createCustomerEndpointAgentToolCustomerCreatePost'];
};
/**
 * @summary Get Availability Endpoint
 * @description Get available appointment slots for a customer and service type.
 */
export const getAvailabilityEndpointAgentToolAvailabilityListPost = {
  schema: {
    method: 'post',
    url: '/agent/tool/availability/list',
    mediaType: ['application/json'],
  },
} as {
  schema: GetAvailabilityEndpointAgentToolAvailabilityListPostSchema;
  [QraftServiceOperationsToken]: AgentToolsService['getAvailabilityEndpointAgentToolAvailabilityListPost'];
};
/**
 * @summary List Appointments Endpoint
 * @description List appointments for a customer.
 */
export const listAppointmentsEndpointAgentToolAppointmentListPost = {
  schema: {
    method: 'post',
    url: '/agent/tool/appointment/list',
    mediaType: ['application/json'],
  },
} as {
  schema: ListAppointmentsEndpointAgentToolAppointmentListPostSchema;
  [QraftServiceOperationsToken]: AgentToolsService['listAppointmentsEndpointAgentToolAppointmentListPost'];
};
/**
 * @summary List Past Appointments Endpoint
 * @description List past appointments for a customer.
 */
export const listPastAppointmentsEndpointAgentToolAppointmentListPastPost = {
  schema: {
    method: 'post',
    url: '/agent/tool/appointment/list_past',
    mediaType: ['application/json'],
  },
} as {
  schema: ListPastAppointmentsEndpointAgentToolAppointmentListPastPostSchema;
  [QraftServiceOperationsToken]: AgentToolsService['listPastAppointmentsEndpointAgentToolAppointmentListPastPost'];
};
/**
 * @summary List Upcoming Appointments Endpoint
 * @description List upcoming appointments for a customer.
 */
export const listUpcomingAppointmentsEndpointAgentToolAppointmentListUpcomingPost = {
  schema: {
    method: 'post',
    url: '/agent/tool/appointment/list_upcoming',
    mediaType: ['application/json'],
  },
} as {
  schema: ListUpcomingAppointmentsEndpointAgentToolAppointmentListUpcomingPostSchema;
  [QraftServiceOperationsToken]: AgentToolsService['listUpcomingAppointmentsEndpointAgentToolAppointmentListUpcomingPost'];
};
/**
 * @summary Book Appointment Endpoint
 * @description Book a new appointment for a customer.
 */
export const bookAppointmentEndpointAgentToolAppointmentBookPost = {
  schema: {
    method: 'post',
    url: '/agent/tool/appointment/book',
    mediaType: ['application/json'],
  },
} as {
  schema: BookAppointmentEndpointAgentToolAppointmentBookPostSchema;
  [QraftServiceOperationsToken]: AgentToolsService['bookAppointmentEndpointAgentToolAppointmentBookPost'];
};
/**
 * @summary Reschedule Appointment Endpoint
 * @description Reschedule an existing appointment.
 */
export const rescheduleAppointmentEndpointAgentToolAppointmentReschedulePost = {
  schema: {
    method: 'post',
    url: '/agent/tool/appointment/reschedule',
    mediaType: ['application/json'],
  },
} as {
  schema: RescheduleAppointmentEndpointAgentToolAppointmentReschedulePostSchema;
  [QraftServiceOperationsToken]: AgentToolsService['rescheduleAppointmentEndpointAgentToolAppointmentReschedulePost'];
};
/**
 * @summary Cancel Appointment Endpoint
 * @description Cancel an appointment.
 */
export const cancelAppointmentEndpointAgentToolAppointmentCancelPost = {
  schema: {
    method: 'post',
    url: '/agent/tool/appointment/cancel',
    mediaType: ['application/json'],
  },
} as {
  schema: CancelAppointmentEndpointAgentToolAppointmentCancelPostSchema;
  [QraftServiceOperationsToken]: AgentToolsService['cancelAppointmentEndpointAgentToolAppointmentCancelPost'];
};
/**
 * @summary Add Appointment Note Endpoint
 * @description Add a note to an appointment by appending to any existing notes.
 */
export const addAppointmentNoteEndpointAgentToolAppointmentAddNotePost = {
  schema: {
    method: 'post',
    url: '/agent/tool/appointment/add_note',
    mediaType: ['application/json'],
  },
} as {
  schema: AddAppointmentNoteEndpointAgentToolAppointmentAddNotePostSchema;
  [QraftServiceOperationsToken]: AgentToolsService['addAppointmentNoteEndpointAgentToolAppointmentAddNotePost'];
};
export const agentToolsService = {
  getCustomersByPhoneEndpointAgentToolCustomerGetByPhonePost,
  getCustomersByZipcodeEndpointAgentToolCustomerGetByZipcodePost,
  searchCustomersByAddressEndpointAgentToolCustomerSearchByAddressPost,
  createCustomerEndpointAgentToolCustomerCreatePost,
  getAvailabilityEndpointAgentToolAvailabilityListPost,
  listAppointmentsEndpointAgentToolAppointmentListPost,
  listPastAppointmentsEndpointAgentToolAppointmentListPastPost,
  listUpcomingAppointmentsEndpointAgentToolAppointmentListUpcomingPost,
  bookAppointmentEndpointAgentToolAppointmentBookPost,
  rescheduleAppointmentEndpointAgentToolAppointmentReschedulePost,
  cancelAppointmentEndpointAgentToolAppointmentCancelPost,
  addAppointmentNoteEndpointAgentToolAppointmentAddNotePost,
} as const;
type GetCustomersByPhoneEndpointAgentToolCustomerGetByPhonePostSchema = {
  method: 'post';
  url: '/agent/tool/customer/get_by_phone';
  mediaType: ['application/json'];
};
type GetCustomersByPhoneEndpointAgentToolCustomerGetByPhonePostParameters = {
  query?: never;
  header?: never;
  path?: never;
};
type GetCustomersByPhoneEndpointAgentToolCustomerGetByPhonePostData =
  paths['/agent/tool/customer/get_by_phone']['post']['responses']['200']['content']['application/json'];
type GetCustomersByPhoneEndpointAgentToolCustomerGetByPhonePostError =
  paths['/agent/tool/customer/get_by_phone']['post']['responses']['422']['content']['application/json'];
type GetCustomersByPhoneEndpointAgentToolCustomerGetByPhonePostBody =
  paths['/agent/tool/customer/get_by_phone']['post']['requestBody']['content']['application/json'];
type GetCustomersByZipcodeEndpointAgentToolCustomerGetByZipcodePostSchema = {
  method: 'post';
  url: '/agent/tool/customer/get_by_zipcode';
  mediaType: ['application/json'];
};
type GetCustomersByZipcodeEndpointAgentToolCustomerGetByZipcodePostParameters = {
  query?: never;
  header?: never;
  path?: never;
};
type GetCustomersByZipcodeEndpointAgentToolCustomerGetByZipcodePostData =
  paths['/agent/tool/customer/get_by_zipcode']['post']['responses']['200']['content']['application/json'];
type GetCustomersByZipcodeEndpointAgentToolCustomerGetByZipcodePostError =
  paths['/agent/tool/customer/get_by_zipcode']['post']['responses']['422']['content']['application/json'];
type GetCustomersByZipcodeEndpointAgentToolCustomerGetByZipcodePostBody =
  paths['/agent/tool/customer/get_by_zipcode']['post']['requestBody']['content']['application/json'];
type SearchCustomersByAddressEndpointAgentToolCustomerSearchByAddressPostSchema = {
  method: 'post';
  url: '/agent/tool/customer/search_by_address';
  mediaType: ['application/json'];
};
type SearchCustomersByAddressEndpointAgentToolCustomerSearchByAddressPostParameters = {
  query?: never;
  header?: never;
  path?: never;
};
type SearchCustomersByAddressEndpointAgentToolCustomerSearchByAddressPostData =
  paths['/agent/tool/customer/search_by_address']['post']['responses']['200']['content']['application/json'];
type SearchCustomersByAddressEndpointAgentToolCustomerSearchByAddressPostError =
  paths['/agent/tool/customer/search_by_address']['post']['responses']['422']['content']['application/json'];
type SearchCustomersByAddressEndpointAgentToolCustomerSearchByAddressPostBody =
  paths['/agent/tool/customer/search_by_address']['post']['requestBody']['content']['application/json'];
type CreateCustomerEndpointAgentToolCustomerCreatePostSchema = {
  method: 'post';
  url: '/agent/tool/customer/create';
  mediaType: ['application/json'];
};
type CreateCustomerEndpointAgentToolCustomerCreatePostParameters = {
  query?: never;
  header?: never;
  path?: never;
};
type CreateCustomerEndpointAgentToolCustomerCreatePostData =
  paths['/agent/tool/customer/create']['post']['responses']['200']['content']['application/json'];
type CreateCustomerEndpointAgentToolCustomerCreatePostError =
  paths['/agent/tool/customer/create']['post']['responses']['422']['content']['application/json'];
type CreateCustomerEndpointAgentToolCustomerCreatePostBody =
  paths['/agent/tool/customer/create']['post']['requestBody']['content']['application/json'];
type GetAvailabilityEndpointAgentToolAvailabilityListPostSchema = {
  method: 'post';
  url: '/agent/tool/availability/list';
  mediaType: ['application/json'];
};
type GetAvailabilityEndpointAgentToolAvailabilityListPostParameters = {
  query?: never;
  header?: never;
  path?: never;
};
type GetAvailabilityEndpointAgentToolAvailabilityListPostData =
  paths['/agent/tool/availability/list']['post']['responses']['200']['content']['application/json'];
type GetAvailabilityEndpointAgentToolAvailabilityListPostError =
  paths['/agent/tool/availability/list']['post']['responses']['422']['content']['application/json'];
type GetAvailabilityEndpointAgentToolAvailabilityListPostBody =
  paths['/agent/tool/availability/list']['post']['requestBody']['content']['application/json'];
type ListAppointmentsEndpointAgentToolAppointmentListPostSchema = {
  method: 'post';
  url: '/agent/tool/appointment/list';
  mediaType: ['application/json'];
};
type ListAppointmentsEndpointAgentToolAppointmentListPostParameters = {
  query?: never;
  header?: never;
  path?: never;
};
type ListAppointmentsEndpointAgentToolAppointmentListPostData =
  paths['/agent/tool/appointment/list']['post']['responses']['200']['content']['application/json'];
type ListAppointmentsEndpointAgentToolAppointmentListPostError =
  paths['/agent/tool/appointment/list']['post']['responses']['422']['content']['application/json'];
type ListAppointmentsEndpointAgentToolAppointmentListPostBody =
  paths['/agent/tool/appointment/list']['post']['requestBody']['content']['application/json'];
type ListPastAppointmentsEndpointAgentToolAppointmentListPastPostSchema = {
  method: 'post';
  url: '/agent/tool/appointment/list_past';
  mediaType: ['application/json'];
};
type ListPastAppointmentsEndpointAgentToolAppointmentListPastPostParameters = {
  query?: never;
  header?: never;
  path?: never;
};
type ListPastAppointmentsEndpointAgentToolAppointmentListPastPostData =
  paths['/agent/tool/appointment/list_past']['post']['responses']['200']['content']['application/json'];
type ListPastAppointmentsEndpointAgentToolAppointmentListPastPostError =
  paths['/agent/tool/appointment/list_past']['post']['responses']['422']['content']['application/json'];
type ListPastAppointmentsEndpointAgentToolAppointmentListPastPostBody =
  paths['/agent/tool/appointment/list_past']['post']['requestBody']['content']['application/json'];
type ListUpcomingAppointmentsEndpointAgentToolAppointmentListUpcomingPostSchema = {
  method: 'post';
  url: '/agent/tool/appointment/list_upcoming';
  mediaType: ['application/json'];
};
type ListUpcomingAppointmentsEndpointAgentToolAppointmentListUpcomingPostParameters = {
  query?: never;
  header?: never;
  path?: never;
};
type ListUpcomingAppointmentsEndpointAgentToolAppointmentListUpcomingPostData =
  paths['/agent/tool/appointment/list_upcoming']['post']['responses']['200']['content']['application/json'];
type ListUpcomingAppointmentsEndpointAgentToolAppointmentListUpcomingPostError =
  paths['/agent/tool/appointment/list_upcoming']['post']['responses']['422']['content']['application/json'];
type ListUpcomingAppointmentsEndpointAgentToolAppointmentListUpcomingPostBody =
  paths['/agent/tool/appointment/list_upcoming']['post']['requestBody']['content']['application/json'];
type BookAppointmentEndpointAgentToolAppointmentBookPostSchema = {
  method: 'post';
  url: '/agent/tool/appointment/book';
  mediaType: ['application/json'];
};
type BookAppointmentEndpointAgentToolAppointmentBookPostParameters = {
  query?: never;
  header?: never;
  path?: never;
};
type BookAppointmentEndpointAgentToolAppointmentBookPostData =
  paths['/agent/tool/appointment/book']['post']['responses']['200']['content']['application/json'];
type BookAppointmentEndpointAgentToolAppointmentBookPostError =
  paths['/agent/tool/appointment/book']['post']['responses']['422']['content']['application/json'];
type BookAppointmentEndpointAgentToolAppointmentBookPostBody =
  paths['/agent/tool/appointment/book']['post']['requestBody']['content']['application/json'];
type RescheduleAppointmentEndpointAgentToolAppointmentReschedulePostSchema = {
  method: 'post';
  url: '/agent/tool/appointment/reschedule';
  mediaType: ['application/json'];
};
type RescheduleAppointmentEndpointAgentToolAppointmentReschedulePostParameters = {
  query?: never;
  header?: never;
  path?: never;
};
type RescheduleAppointmentEndpointAgentToolAppointmentReschedulePostData =
  paths['/agent/tool/appointment/reschedule']['post']['responses']['200']['content']['application/json'];
type RescheduleAppointmentEndpointAgentToolAppointmentReschedulePostError =
  paths['/agent/tool/appointment/reschedule']['post']['responses']['422']['content']['application/json'];
type RescheduleAppointmentEndpointAgentToolAppointmentReschedulePostBody =
  paths['/agent/tool/appointment/reschedule']['post']['requestBody']['content']['application/json'];
type CancelAppointmentEndpointAgentToolAppointmentCancelPostSchema = {
  method: 'post';
  url: '/agent/tool/appointment/cancel';
  mediaType: ['application/json'];
};
type CancelAppointmentEndpointAgentToolAppointmentCancelPostParameters = {
  query?: never;
  header?: never;
  path?: never;
};
type CancelAppointmentEndpointAgentToolAppointmentCancelPostData =
  paths['/agent/tool/appointment/cancel']['post']['responses']['200']['content']['application/json'];
type CancelAppointmentEndpointAgentToolAppointmentCancelPostError =
  paths['/agent/tool/appointment/cancel']['post']['responses']['422']['content']['application/json'];
type CancelAppointmentEndpointAgentToolAppointmentCancelPostBody =
  paths['/agent/tool/appointment/cancel']['post']['requestBody']['content']['application/json'];
type AddAppointmentNoteEndpointAgentToolAppointmentAddNotePostSchema = {
  method: 'post';
  url: '/agent/tool/appointment/add_note';
  mediaType: ['application/json'];
};
type AddAppointmentNoteEndpointAgentToolAppointmentAddNotePostParameters = {
  query?: never;
  header?: never;
  path?: never;
};
type AddAppointmentNoteEndpointAgentToolAppointmentAddNotePostData =
  paths['/agent/tool/appointment/add_note']['post']['responses']['200']['content']['application/json'];
type AddAppointmentNoteEndpointAgentToolAppointmentAddNotePostError =
  paths['/agent/tool/appointment/add_note']['post']['responses']['422']['content']['application/json'];
type AddAppointmentNoteEndpointAgentToolAppointmentAddNotePostBody =
  paths['/agent/tool/appointment/add_note']['post']['requestBody']['content']['application/json'];
